<template>
  <div class="box" style="width: 100%;height: 1860px;background: #ffffff;position: relative">
    <div id="demoCanvas" ref="demoCanvas"></div>
    <div class="header_container" style="width: 1080px;height: 705px" >
      <header style="width: 1080px;height: 610px">
        <!-- <el-image style="width: 1080px;height: 610px" :src="moren"/> -->
        <!--
          <div v-if="this.img_data.length === 0">
            <el-image style="width: 1080px;height: 610px" :src="moren"/>
          </div>
        -->
        <div v-if="this.img_data.length === 0">
          <el-image style="width: 100%;height: 100%;" :src="moren"/>
        </div>
        <el-carousel v-if="isVisible && this.img_data.length !== 0" class="new-item1 new-item2" :autoplay="autoplay" arrow="never" indicator-position="none"
                     ref="bdbiShow" @change="changeplay" :initial-index="initialIndex" height="610px" :interval="interval" @click.native="handleCarouselClick">
          <el-carousel-item class="carousel flex" v-for="(item, index) in img_data" :key="index" tabindex="-1">
            <!--            <div> indicator-position="none" @click.native="handleCarouselClick"-->
            <!--              <video-player ref="player" :options="playerOptions"></video-player>-->
            <!--              <button @click="play">播放</button>-->
            <!--              <button @click="pause">暂停</button>-->
            <!--            </div>-->
            <div class="content-wrapper">
              <el-image v-if="item.bdbi_path.indexOf('.mp4') ==-1" :class="item.bdbi_tbs_id? 'img_title_cursor': 'img_title'" :src="item.bdbi_path" @error="srcerr1(item,$event)" @click="jrcsImg(item.bdbi_tbs_id, item.bdbi_tbs_type)"/>
              <video class="img_title" v-else :ref="'player' + index" preload="auto">
                <source :src="item.bdbi_path" type="video/mp4">
                您的浏览器不支持Video标签。
              </video>
            </div>

            <!--            <vue-core-video-player :ref="'player' + index" v-else :src="item.bdbi_path" :loop="true" preload autoplay></vue-core-video-player>-->
            <!--            <vue-core-video-player :ref="'player' + index" v-else :src="videoUrl" :loop="true" autoplay></vue-core-video-player>-->
          </el-carousel-item>
        </el-carousel>
        <!--        <el-carousel :autoplay="true" arrow="never" :initial-index="0" height="610px" :interval="15000">-->
        <!--          <el-carousel-item>-->
        <!--            &lt;!&ndash;-->
        <!--             <div v-if="item.bdbi_path.indexOf('.mp4') == -1">-->
        <!--               <el-image style="width: 1080px;height: 610px" :src="moren"/>-->
        <!--             </div>-->
        <!--              <vue-core-video-player v-else :src="videoUrl" :loop="true" autoplay></vue-core-video-player>-->
        <!--            &ndash;&gt;-->
        <!--            <el-image style="width: 1080px;height: 610px" :src="moren"/>-->
        <!--          </el-carousel-item>-->
        <!--        </el-carousel>-->
      </header>
      <nav>
          <el-carousel :interval="carouseInterval" :autoplay="true" width="1040px" height="90px" @change="handleCarouselChange" arrow="never" indicator-position="none">
            <el-carousel-item  v-for="(i, index) in imageListLength" :key="index">
              <div style="width: 1040px;display: flex;justify-content:space-between;  margin: 5px 20px 0;gap: 10px;">
                  <el-image style="width: 160px;height: 80px"  :src="item.image_path"  @click="imageClick(item.type)" v-for="(item, index) in visibleItems" :key="index"/>
              </div>
            </el-carousel-item>
          </el-carousel>

      </nav>
    </div>

    <div class="part1">
      <div style="display: flex;width: 100%;height: 75px;justify-content: space-between;">
        <div style="display: flex;line-height: 75px;">
          <div  style="color: #ff770f;font-size: 36px;font-weight: bold;">
            便利惠
          </div>
          <div style="margin: 0 20px;font-size: 36px;">|</div>
          <div  style="font-size: 36px;display: flex;">好物立得，更实惠</div></div>
        <div style="line-height: 75px;font-size: 36px;font-weight: 400;"
             @click='SVGA()'  >
          更多<i class="el-icon-arrow-right"/>
        </div>
      </div>
<!--      <el-carousel :interval="goodsInterval" :autoplay="true" width="1080px" height="430px" @change="goodsCarouselChange" arrow="never" indicator-position="none">-->
<!--        &lt;!&ndash; 动态绑定当前显示的 4 个元素 &ndash;&gt;-->
<!--        <el-carousel-item  v-for="(i, index) in goodsListLength" :key="index" class="el-carousel-none">-->
          <div style="display: flex; width: 100%;">
            <div :class="item.count_num <= 0 ?'content_mask': 'content'" v-for="item in goodsItems"  @click='qr_code_but(item)'>
              <div class="content_img">
                <el-image style="width: 100%;height: 100%;border-top-left-radius: 10px;border-top-right-radius: 10px;" :src="item.mbgi_goods_img_path"/>
              </div>
              <div
                style="width: 199px;height: 42px;line-height: 21px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;word-break:break-all;margin: 0 13px 9px 11px;text-align: center;font-size: 17px">
                {{ item.mbgi_goods_name }}
              </div>
              <div class="relative-div">
                <div v-if="item.count_num == 0">售空</div>
                <div v-if="item.count_num == -1">停用</div>
              </div>
              <div  style="display: flex;margin-bottom: 8px">
              </div>
              <div style="display: flex">
                <div style="height: 22px;font-size: 24px;color: red;margin: 0 7px 7px 11px;line-height: 22px;font-weight: bold;">
                  <span style="font-size: 15px">￥</span>{{ item.mbgi_money_3 }}
                </div>
                <div style="color: rgb(187,187,187);margin-top: 3px;text-decoration: line-through;font-size: 15px;font-weight: bold;">
                  <span style="font-size: 15px">￥</span>{{ item.mbgi_money_1 }}
                </div>
              </div>
              <div class="tip_foot">
                <div class="tip_foot_font">至高省{{ cutZero(parseFloat(item.mbgi_money_1 - item.mbgi_money_3).toFixed(2))}}元</div>
              </div>
            </div>
          </div>
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->

    </div>

    <div class="part2">
      <div style="display: flex;width: 100%;height: 75px;justify-content: space-between;">
        <div style="display: flex;line-height: 75px;">
          <div  style="color: #ff770f;font-size: 36px;font-weight: bold;">
            满减券
          </div>
          <div style="margin: 0 20px;font-size: 36px;">|</div>
          <div  style="font-size: 36px;display: flex;">质选满减，真划算</div>
        </div>
        <div style="line-height: 75px;font-size: 36px;font-weight: 400;"
             @click="ticket_more_click(4)">
          更多<i class="el-icon-arrow-right"/>
        </div>
      </div>
<!--      <el-carousel :interval="quanInterval" :autoplay="true" width="1080px" height="230px" @change="handleQuanlChange" arrow="never" indicator-position="none">-->
<!--        &lt;!&ndash; 动态绑定当前显示的 4 个元素 &ndash;&gt;-->
<!--        <el-carousel-item  v-for="(i, index) in quanListLength" :key="index" class="el-carousel-none">-->
          <div style="display: flex;">
            <!--        <div style="width: 39px;height: 135px;margin: 39px 8px 0 14px">-->
            <!--          <el-image :src="manjian"/>-->
            <!--        </div>-->
            <div v-for="item in quanItems" style="margin-right: 19px;">
              <div class="content2"  @click="lijian_click(item, 4)">
                <div class="trapezoid-down-transform">{{ item.bii_name }}</div>
                <div class="manjianqu_title_home">
                  <el-image :src="item.bmi_mer_icon?item.bmi_mer_icon:moren"
                            style="width: 15px;height: 15px;border-radius: 15px;"/>
                  {{item.bmi_mer_name.length > 6 ? item.bmi_mer_name.substring(0,5) + '...': item.bmi_mer_name}}
                </div>
                  <div class="manjianqu_bq_home">
                    <div v-for="(tag,index) in item.signs" :key="index" style="font-size: 10px; border-radius: 4px;color:red;
                           border: 1px solid red;display: flex;padding: 2px 2px;"  v-if="index < 2">
                      {{ tag.tsi_name }}
                    </div>
<!--                    <div class="manjianqu_bq_div" v-for="(tag,index) in item.signs" :key="index"  v-if="index < 2">-->
<!--                      {{ tag.tsi_name }}-->
<!--                    </div>-->
                  </div>
                <div style="width: 100%;font-size: 40px;font-weight: bold;color: #E02E24;display: flex;justify-content: center;align-items: flex-start;">
                  <span>{{ parseInt(item.mti_money_2) }}</span><span style="font-size: 24px;margin-top: 20px;">元</span>
                </div>

                <div
                  style="width: 100%;font-size: 18px;margin-top: -10px;margin-bottom: 40px;">
                  满{{ parseInt(item.mti_money_1) }}即用
                </div>
                <div class="manjianqu_btn">
                  <el-image :src='manjian_btn'/>
                </div>
              </div>
            </div>
          </div>
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->

    </div>
    <div class="part3">
      <div style="display: flex;width: 100%;height: 75px;justify-content: space-between;">
        <div style="display: flex;line-height: 75px;">
          <div  style="color: #ff770f;font-size: 36px;font-weight: bold;">
            立减券
          </div>
          <div style="margin: 0 20px;font-size: 36px;">|</div>
          <div  style="font-size: 36px;display: flex;">超值立减，真省钱</div>
        </div>
        <div style="line-height: 75px;font-size: 36px;font-weight: 400;"
             @click="ticket_more_click(3)">
          更多<i class="el-icon-arrow-right"/>
        </div>
      </div>
<!--      <el-carousel :interval="lquanInterval" :autoplay="true" width="1080px" height="230px" @change="handleLquanlChange" arrow="never" indicator-position="none">-->
<!--        &lt;!&ndash; 动态绑定当前显示的 4 个元素 &ndash;&gt;-->
<!--        <el-carousel-item  v-for="(i, index) in lquanListLength" :key="index" class="el-carousel-none">-->
        <div style="width: 100%;display: flex;flex-wrap: wrap;justify-content: space-between;">
          <div v-for="item in lquanItems">
            <div class="content3" @click="lijian_click(item, 3)">
              <div style="display: flex;padding:7px;">
                <div :style="{'margin-top': item.bmi_mer_pb_path?'-20px' : '0px'}">
                  <div class="img_mask">
                    <el-image v-if="item.bmi_mer_pb_path" style="width: 18px;  height: 18px;" :src='item.bmi_mer_pb_path'/>
                    <span style="font-size: 11px;line-height: 18px;">{{item.bmi_mer_pb}}</span>
                  </div>
                  <el-image style="width: 100px;height: 100px;" :src='item.mti_img_path'/>
                  <div v-if="item.bjSigns.length>0" class="sign_mask">
                    <div v-for="(tag,index) in item.bjSigns" :key="index" style="font-size: 11px; color:#ffffff;" v-if="index < 2">
                      {{ tag.tsi_name }}
                    </div>
                  </div>
                </div>
                <div style="display: flex;flex-direction: column;justify-content: space-between;width:275px;height: 110px;">
                  <div
                    style="width: 275px;font-size: 22px;font-weight: bold;color: #333333;line-height: 20px;text-align: left;margin: 8px 5px 5px 5px">
                    {{item.mti_name.length > 12 ? item.mti_name.substring(0,11) + '..': item.mti_name}}
                  </div>
                  <div v-if="item.otherSigns.length>0" style="display: flex;flex-wrap: wrap;">
                    <div v-for="(tag,index) in item.otherSigns" :key="index" style="font-size: 12px; border-radius: 4px;color:red;
                           border: 1px solid red;display: flex;padding: 2px 4px;margin-top: 5px; margin-left: 3px;margin-right: 2px;">
                          {{ tag.tsi_name }}
                    </div>
                  </div>
                  <div style="display: flex;font-size: 17px;font-weight: bold;margin-left: 5px;margin-bottom: 10px;height: 22px;line-height: 22px;">
                    <div style="color: #E02E24;margin-right: 5px;">
                      券后价:<span style="font-size: 12px;">￥</span>{{ item.mti_money_2 }}
                    </div>
                    <div style="font-size: 14px;">
                     门市价: <span style="font-size: 12px;">￥</span><span style="text-decoration: line-through;">{{ item.mti_money_1 }}</span>
                    </div>

                  </div>
                </div>

                <el-image :src="xuxian" style="width: 2px;height: 80px;margin: 10px 0"/>
                <div
                  style="height: 100%;width: 90px;display: flex;flex-direction: column;align-items: center;">
                  <div style="font-size: 22px;font-weight: bold;">立减</div>
                  <div
                    style="font-size: 26px;font-weight: bold;color: #E02E24;">
                    {{ item.mti_lijian }}<span style="font-size: 18px">元</span></div>
                  <div class="ling">
                    <div style="color: white;font-size: 13px">
                      立即领
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->

    </div>

    <!-- 立减商品详情弹窗 -->
    <div class="dialog-detail" v-if="lijian_dialog_show">
      <div class="dialog_box_ticket">

        <div class="box_part1">
          <div style="display: flex;margin: 25px 0 0 15px;">
            <div
              style="font-size: 30px;font-weight: bold;color: #444444;width: 740px;text-align: left;margin-top: 3px">
              商家信息
            </div>
            <div>
              <el-image :src="close1" @click="close_click(1)" style="width: 43px;height: 43px"/>
            </div>
          </div>
          <div style="display: flex;margin-bottom: 2px">
            <el-image :src="manjian_data.bmi_mer_icon?manjian_data.bmi_mer_icon:moren"
                      style="width: 140px;height: 90px;margin: 0 10px 0 15px"/>
            <div style="display: flex;flex-direction: column;text-align: left">
              <div style="font-size: 24px;font-weight: 800;color: #444444;">
                {{ manjian_data.bmi_mer_name }}
              </div>
              <div
                style="font-size: 18px;font-weight: 550;color: #444444;line-height: 22px">
                {{ manjian_data.bmst_address }}
              </div>
              <div style="font-size: 12px;color: #444444;">
                营业时间：{{ manjian_data.bms_work_t_name }}
              </div>
              <div style="font-size: 12px;color: #444444;">门店电话：{{
                  manjian_data.bmi_phone
                }}
              </div>
            </div>
          </div>
          <div style="display: flex">
            <el-image :src="dui" style="width: 14px;height: 17px;margin: 2px 5px 0 22px"/>
            <div
              style="font-size: 14px;font-weight: bold;text-decoration: underline;color: #000000;"
              @click="zizhi_show">
              查看经营资质
            </div>
          </div>
        </div>

        <div class="box_part2">
          <div style="width: 598px" v-if="mti_type == 3">
            <div style="display: flex">
              <div style="width: 180px;"><el-image v-if="manjian_data.mti_img_path" :src="manjian_data.mti_img_path" style="width: 155px;height: 155px;margin: 20px 15px 0px 15px"/></div>
              <div class="biaoqian">
                <div
                  style="font-size: 24px;font-weight: bold;color: #FFFFFF;height: 30px">
                  立减
                </div>
                <div style="font-size: 24px;font-weight: bold;color: #FFFFFF;">
                  {{ cutZero(parseFloat(manjian_data.mti_money_1 - manjian_data.mti_money_2).toFixed(2)) }}
                </div>
              </div>
              <div style="display: flex;flex-direction: column">
                <div
                  style="font-size: 32px;font-weight:bold;margin: 10px 0 10px 0;
                  color: #000000;line-height: 30px;text-align: left;max-height: 80px;">
                  {{manjian_data.mti_name.length > 35 ? manjian_data.mti_name.substring(0,34) + '..': manjian_data.mti_name}}
                </div>
                <div style="font-size: 22px;color: #606060;text-align: left;">
                  门市价：￥<span
                  style="text-decoration: line-through">{{ manjian_data.mti_money_1 }}</span></div>
                <div style="display: flex;">
                  <div
                    style="font-size: 22px;color: #000000;text-align: left;font-weight:bold;">
                    券后价：￥<span style="color: red"><span style="font-size: 36px">{{
                      manjian_data.mti_money_2
                    }}</span></span>
                  </div>
                  <div
                    style="color: red;border: 1px solid red;border-radius: 6px;height: 22px;width: 54px;line-height: 22px;margin-left: 10px;margin-top: 20px">
                    {{ discount }}折
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex;font-size: 16px;justify-content: flex-start;">
              <div v-for="(item,index) in bjSigns" :key="index" class="sign_name">
                {{ item.tsi_name }}
              </div>
            </div>
            <div style="display: flex;font-size: 16px;justify-content: flex-start;">
              <div v-for="(item,index) in otherSigns" :key="index" class="sign_name">
                  {{ item.tsi_name }}
              </div>
            </div>
          </div>
          <div v-else style="width: 598px">
            <div style="display: flex">
              <div
                style="width: 200px;height: 100px;font-size: 100px;margin: 50px 0 20px 20px;line-height: 100px;font-weight: bold;color: #E02E24;">
                {{ manjian_data.mti_money_2 }}
              </div>
              <div style="display: flex;flex-direction: column;margin-top: 55px">
                <div
                  style="text-align: left;font-size: 30px;font-weight: bold;color: #E1352C;">
                  元优惠券
                </div>
                <div
                  style="text-align: left;font-size: 30px;font-weight: bold;color: #474747;">
                  消费满{{ manjian_data.mti_money_1 }}元使用
                </div>
              </div>
            </div>
            <div style="display: flex;font-size: 16px;justify-content: flex-start;padding-left: 30px;">
              <div v-for="(item,index) in bjSigns" :key="index" class="sign_name">
                {{ item.tsi_name }}
              </div>
            </div>
            <div style="display: flex;font-size: 16px;justify-content: flex-start;padding-left: 30px;">
              <div v-for="(item,index) in otherSigns" :key="index" class="sign_name">
                {{ item.tsi_name }}
              </div>
            </div>
          </div>
          <el-image :src="xuxian" style="width: 2px;height: 200px;margin: 15px 0 0 0"/>
          <div>
            <el-image v-if="manjian_data.mti_code_img_path" :src="manjian_data.mti_code_img_path" style="width: 127px;height: 127px;margin: 20px 0 2px 25px"/>
            <div
              style="font-size: 18px;font-weight: bold;color: #000000;margin-left: 5px;display: flex">
              <el-image :src="weixin" style="width: 20px;height: 20px;margin: 4px 3px 0 12px"/>
              <div>微信扫码领取</div>
            </div>
            <div
              style="font-size: 15px;font-weight: bold;color: #313131;margin-left: 15px">
              (查看更多详情)
            </div>
          </div>
        </div>

        <div class="box_part3">
          <div
            style="font-size: 24px;font-weight: bold;color: #4B4B4B;text-align: left;padding-top: 10px">
            【优惠详情】
          </div>
          <div
            style="white-space:pre-line;line-height: 30px;text-align: left;font-size: 18px;color: #313131;padding:5px 10px;">{{ manjian_data.mti_shop_content }}</div>

          <div style="font-size: 24px;font-weight: bold;color: #4B4B4B;text-align: left">
            【用券须知】
          </div>
          <div
            style="white-space:pre-line;line-height: 30px;text-align: left;font-size: 18px;color: #313131;padding:5px 10px;">{{ manjian_data.mti_note }}</div>

          <div style="font-size: 24px;font-weight: bold;color: #4B4B4B;text-align: left">
            【限制条件】
          </div>
          <div
            style="white-space:pre-line;line-height: 30px;text-align: left;font-size: 18px;color: #313131;padding:5px 10px;">{{ manjian_data.mti_limit_condition }}</div>
        </div>

        <div
          style="font-size: 25px;font-weight: bold;color: #313131;margin: 20px 0 15px 10px;width: 180px">
          【用券方法】
        </div>
        <div style="display: flex;">
          <div class="box_foot" style="margin-left: 23px;position: relative">
            <div class="box_foot_content">微信打开小程序
              <el-image :src="xiaochengxu" style="width:24px;height:24px;position: absolute;left: 60px;top: 50px"/>
            </div>
          </div>
<!--          <el-image :src="jiantou1" style="width: 17px;height: 26px;margin: 30px 22px 0 22px"/>-->
<!--          <div class="box_foot">-->
<!--            <div class="box_foot_content">进入“我的”</div>-->
<!--          </div>-->
          <el-image :src="jiantou1" style="width: 17px;height: 26px;margin: 30px 22px 0 22px"/>
          <div class="box_foot">
            <div class="box_foot_content">进入“我的券包”</div>
          </div>
          <el-image :src="jiantou1" style="width: 17px;height: 26px;margin: 30px 22px 0 22px"/>
          <div class="box_foot">
            <div class="box_foot_content">点选出示使用的优惠券</div>
          </div>

        </div>

      </div>
    </div>

    <!--    金融超市弹出窗口-->
    <div class="dialog" v-if="jrcsDialog">
      <div class="dialog_box_supermarket">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;width: 100%;font-weight: bold">
          金融产品甄选区
        </div>
        <el-image :src="close1" @click="jrcs_close()"
                  style="width: 43px;height: 43px;position: absolute;left: 750px;top: 50px"/>
        <div style="display: flex;width: 100%;height: 40px;justify-content: space-between;margin-bottom: 12px;margin-top: 30px;">
          <div style="display: flex;padding-top: 4px;margin-left: 34px;">
            <div :class="tbs_type === 1?'supermarket_font_click':'supermarket_font'"  @click="supermarket_details(1)">
              个人存款
              <div v-if="tbs_type === 1" class="tar-line" style="width: 100%;"></div>
            </div>
            <div class="div_line">|</div>
            <div :class="tbs_type === 2?'supermarket_font_click':'supermarket_font'"    @click="supermarket_details(2)">
              个人贷款
              <div v-if="tbs_type === 2" class="tar-line" style="width: 100%;"></div>
            </div>
            <div class="div_line">|</div>
            <div :class="tbs_type === 3?'supermarket_font_click':'supermarket_font'"  @click="supermarket_details(3)">
              信用卡
              <div v-if="tbs_type === 3" class="tar-line" style="width: 100%;"></div>
            </div>
            <div class="div_line">|</div>
            <div :class="tbs_type === 4?'supermarket_font_click':'supermarket_font'"  @click="supermarket_details(4)">
              商家收款
              <div v-if="tbs_type === 4" class="tar-line" style="width: 100%;"></div>
            </div>
            <div class="div_line">|</div>
            <div :class="tbs_type === 5?'supermarket_font_click':'supermarket_font'"  @click="supermarket_details(5)">
              投资理财
              <div v-if="tbs_type === 5" class="tar-line" style="width: 100%;"></div>
            </div>
          </div>
        </div>
        <div class="supermarket_content">
          <div class="supermarket_title">
            <div :class="index == supermarketIndex ? 'supermarket_title_div_click':'supermarket_title_div'" v-for="item, index in supermarketData"  @click='supermarket_content(item, index)'>
              {{item.tbs_name.length > 5 ? item.tbs_name.substring(0,4) + '..': item.tbs_name}}
            </div>
          </div>
          <div v-if="supermarket.tbs_name" class="box_part_supermarket">
            <div style="font-size: 36px;font-weight: bold;">
              {{supermarket.tbs_name}}
            </div>
            <div class="dashed"></div>
            <el-image v-if="supermarket.tbs_img_path" style="width: 268px;height: 152px;margin-top: 10px;" :src="supermarket.tbs_img_path"/>
<!--            <div v-if="supermarket.tbs_img_path">-->
<!--              <el-image  style="width: 268px;height: 152px" :src="supermarket.tbs_img_path"/>-->
<!--            </div>-->
<!--            <div v-else style="height: 152px">-->
<!--            </div>-->
            <div style="display: flex;width: 100%;margin-top: 19px;">
              <el-image style="width: 16px;height: 16px;margin-top: 3px;" :src="biaozhu"/>
              <div style="font-weight: bold;font-size: 26px;margin-left: 5px;margin-bottom: 5px;">产品介绍</div>
            </div>
            <div :class="supermarket.tbs_img_path ? 'box_supermarket_content':'box_supermarket_content_noimage' ">
              <el-input style="font-size: 20px;" type="textarea" readonly :class="supermarket.tbs_img_path ? 'custom-textarea':'custom-textarea_noimage' " v-model="supermarket.tbs_content" />
            </div>
            <div class="dashed"></div>
            <div style="display: flex;width: 100%; height:150px; margin-top: 5px;">
              <div style="display: flex;flex-direction: column; width:49%">
                <div style="display: flex;">
                  <el-image style="width: 16px;height: 16px;margin-top: 3px;" :src="biaozhu"/>
                  <div style="font-weight: bold;font-size: 18px;margin-left: 5px;">业务咨询</div>
                </div>
                <div style="display: flex;opacity: 0.8;align-items: center;height: 100%;">
                  <el-input type="textarea" readonly class="no-border-input"  v-model="supermarket.tbs_business" />
                </div>
              </div>
              <div class="dashed-shu"></div>
              <div style="display: flex;flex-direction: column; width:49%">
                <div style="display: flex;">
                  <el-image style="width: 16px;height: 16px;margin-top: 3px;" :src="biaozhu"/>
                  <div style="font-weight: bold;font-size: 18px;margin-left: 5px;">自助办理通道</div>
                </div>
                <div v-if="supermarket.tbs_img_qr_path" style="display: flex;flex-direction: column; justify-content: center;align-items: center;height:100%">
                  <el-image style="width: 67px;height: 65px;margin-bottom: 5px;" :src="supermarket.tbs_img_qr_path"/>
                  <div style="opacity: 0.8">{{supermarket.tbs_prompt}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="box_part_supermarket"></div>
        </div>
      </div>
    </div>

    <!--    活动专区弹出窗口-->
    <div class="dialog" v-if="hdzqDialog">
      <div class="dialog_box_hdzq">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;width: 100%;font-weight: bold">
          限量惠
        </div>
        <el-image :src="close1" @click="hdzq_close"
                  style="width: 43px;height: 43px;position: absolute;left: 765px;top: 30px"/>
        <div style="display: flex;margin-right: 18px;width: 97%;justify-content: flex-end;">
          <div class="box_part8" @click="pre_page_hdzq">
            上一页
          </div>
          <div class="box_part8" @click="next_page_hdzq">
            下一页
          </div>
        </div>

        <div class="hdzq_content">
          <div v-for="item in hdzqData.rows">
            <div class="hdzq_content_describer">
              <div class="xlh_content_div">
                <div class="text-div"><span class="dot">•</span>{{item.bai_m_caption}}</div>
                <div class="text-div" style="font-size: 16px;padding-left: 17px;">{{item.bai_s_caption}}</div>
              </div>
              <div style="display: flex">
                <div class="custom-textarea-hdzq"> {{replaceMultipleNewlinesWithSingle(item.bai_describer)}} </div>
                <div class="dashed-border"></div>
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;width: 200px;">
                  <div class="image-container">
                    <el-image style="width: 120px;height: 120px;" :src='item.bai_code_img_path? item.bai_code_img_path:bdbi_path_qr'/>
                  </div>
                  <div style="font-size: 16px;color: #3C3C3C;margin-top: 10px;">微信扫码参与</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!--    新客专享弹出窗口-->
    <div class="dialog" v-if="xkzxDialog">
      <div class="dialog_box_hdzq">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;width: 100%;font-weight: bold">
          新客惊喜
        </div>
        <el-image :src="close1" @click="xkzx_close"
                  style="width: 43px;height: 43px;position: absolute;left: 765px;top: 30px"/>
        <div style="display: flex;margin-right: 18px;width: 97%;justify-content: flex-end;">
          <div class="box_part8" @click="pre_page_xkzx">
            上一页
          </div>
          <div class="box_part8" @click="next_page_xkzx">
            下一页
          </div>
        </div>

        <div class="hdzq_content">
          <div v-for="item in xkzxData.rows">
            <div class="hdzq_content_div">
              {{item.tne_name}}
            </div>
            <div class="xkzx_content_describer">
              <div class="custom-textarea-xkzx">
                <el-image style="width: 10px;height: 10px;margin-top: 3px;margin-right: 5px;" :src="biaozhu"/><span style="font-size: 14px;">新客标准</span>
                <div class="xkzx_content">{{replaceMultipleNewlinesWithSingle(item.tne_standard)}}</div>
                <el-image style="width: 10px;height: 10px;margin-top: 3px;margin-right: 5px;" :src="biaozhu"/><span style="font-size: 14px;">权益内容</span>
                <div class="xkzx_content">{{replaceMultipleNewlinesWithSingle(item.tne_content)}}</div>
                <el-image style="width: 10px;height: 10px;margin-top: 3px;margin-right: 5px;" :src="biaozhu"/><span style="font-size: 14px;">参与说明</span>
                <div class="xkzx_content">{{replaceMultipleNewlinesWithSingle(item.tne_access)}}</div>
              </div>
<!--              {{replaceMultipleNewlinesWithSingle(item.tne_access)}} {{replaceMultipleNewlinesWithSingle(item.tne_content)}}-->
              <div class="dashed-xkzx"></div>
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;width: 150px;">
                <div class="image-container">
                  <el-image style="width: 120px;height: 120px;" :src='item.tne_img_path? item.tne_img_path:bdbi_path_qr'/>
                </div>
                <div style="font-size: 16px;color: #3C3C3C;margin-top: 10px;width:110px;">{{item.tne_prompt}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 全行活动弹出窗口-->
    <div class="dialog" v-if="qhhdDialog">
      <div class="dialog_box_hdzq">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;width: 100%;font-weight: bold">
          全行活动
        </div>
        <el-image :src="close1" @click="qhhd_close"
                  style="width: 43px;height: 43px;position: absolute;left: 765px;top: 30px"/>
        <div style="display: flex;margin-right: 18px;width: 97%;justify-content: flex-end;">
          <div class="box_part8" @click="pre_page_qhhd">
            上一页
          </div>
          <div class="box_part8" @click="next_page_qhhd">
            下一页
          </div>
        </div>

        <div class="hdzq_content">
          <div v-for="item in qhhdData.rows">
            <div class="hdzq_content_div">
              {{item.taa_name}}
            </div>
            <div class="xkzx_content_describer">
              <div class="custom-textarea-xkzx">
                <el-image style="width: 10px;height: 10px;margin-top: 3px;margin-right: 5px;" :src="biaozhu"/><span style="font-size: 14px;">活动内容</span>
                <div class="qhhd_content">{{replaceMultipleNewlinesWithSingle(item.taa_content)}}</div>
              </div>
              <div class="dashed-xkzx"></div>
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;width: 150px;">
                <div class="image-container">
                  <el-image style="width: 120px;height: 120px;" :src='item.taa_img_path? item.taa_img_path:bdbi_path_qr'/>
                </div>
                <div style="font-size: 16px;color: #3C3C3C;margin-top: 10px;width:110px;">{{item.taa_prompt}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 福利锦囊弹出窗口-->
    <div class="dialog" v-if="fljnDialog">
      <div class="dialog_box_hdzq">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;width: 100%;font-weight: bold">
          影音会员优惠站
        </div>
        <el-image :src="close1" @click="fljn_close"
                  style="width: 43px;height: 43px;position: absolute;left: 765px;top: 30px"/>

        <div class="hdzq_content">
          <el-image :src="twt_img_path?twt_img_path:kong" style="width: 750px;height: 900px;"/>
        </div>
      </div>
    </div>

    <!-- 合作商家弹出窗口-->
    <div class="dialog" v-if="hzsjDialog">
      <div class="dialog_box_hdzq">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;margin-bottom:20px;width: 100%;font-weight: bold;display: flex;align-items: center;">
          <div style="display: flex;align-items: center;padding-left: 70px;width: 35%;"><el-image :src="hzbm" style="width: 100px;height: 70px;"></el-image></div>
          合作报名
        </div>
        <el-image :src="close1" @click="hzsj_close"
                  style="width: 43px;height: 43px;position: absolute;left: 765px;top: 30px"/>

        <div class="contentOut">
          <div style="display:flex;width:90%;font-weight: bold;margin-left: 20px;font-size: 37px;">合作须知</div>
          <div class="out">
            <label>{{hzbmItem.tcs_name?hzbmItem.tcs_name:''}}</label>
          </div>
          <div style="display:flex;margin-top: 30px;width:90%;font-weight: bold;margin-left: 20px;font-size: 37px;">联系方式</div>
          <div class="out">
            <div>联系人：{{hzbmItem.tcs_contacts?hzbmItem.tcs_contacts:''}}</div>
            <div>电话：{{hzbmItem.tcs_phone?hzbmItem.tcs_phone:''}}</div>
            <div>微信：{{hzbmItem.tcs_wechat?hzbmItem.tcs_wechat:''}}</div>
            <div>邮箱：{{hzbmItem.tcs_email?hzbmItem.tcs_email:''}}</div>
            <div>接待时间：{{hzbmItem.tcs_reception_time?hzbmItem.tcs_reception_time:''}}</div>
          </div>

<!--          <el-image :src="tcm_img_path?tcm_img_path:kong" style="width: 750px;height: 900px;"/>-->
        </div>
      </div>
    </div>

    <!-- 客服中心弹出窗口-->
    <div class="dialog" v-if="bfrxDialog">
      <div class="dialog_box_hdzq">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;margin-bottom:20px;width: 100%;font-weight: bold;display: flex;align-items: center;">
          <div style="display: flex;align-items: center;padding-left: 100px;width: 35%;"><el-image :src="kfzx" style="width: 70px;height: 70px;"></el-image></div>
          客服中心
        </div>
        <el-image :src="close1" @click="bfrx_close"
                  style="width: 43px;height: 43px;position: absolute;left: 765px;top: 30px"/>

        <div class="contentOut">
          <div class="outkf" v-for="(item,index) in kfzxList" :key="index">
            <div style="background-color: #f1c272;width:100%;border-radius: 10px 10px 0px 0px;padding-left: 14px;font-size: 24px;">{{item.tsc_name?item.tsc_name:''}}</div>
            <div style="padding-left: 14px;margin-top: 20px;">服务内容：{{item.tsc_contacts?item.tsc_contacts:''}}</div>
            <div style="padding-left: 14px;">客服电话：{{item.tsc_phone?item.tsc_phone:''}}</div>
            <div style="padding-left: 14px;">工作时间：{{item.tsc_reception_time?item.tsc_reception_time:''}}</div>
          </div>

        </div>
      </div>
    </div>

    <!-- 运营资质弹出窗口-->
    <div class="dialog" v-if="yyzzDialog">
      <div class="dialog_box_hdzq">
        <div
          style="font-size: 57px;color: #76510D;margin-top: 20px;width: 100%;font-weight: bold">
          运营资质
        </div>
        <el-image :src="close1" @click="yyzz_close"
                  style="width: 43px;height: 43px;position: absolute;left: 765px;top: 30px"/>

        <div class="hdzq_content">
          <el-image :src="toq_img_path?toq_img_path:kong" style="width: 750px;height: 900px;"/>
        </div>
      </div>
    </div>

    <!-- 工具券查看更多弹窗 -->
    <div class="dialog" v-if="lijian_more_show">
      <div class="dialog_box">

        <div
          style="font-size: 50px;color: #76510D;margin-top: 50px;width: 100%;font-weight: bold">
          {{ mti_type == 3 ? '立减券' : '满减券' }}
        </div>

        <el-image :src="close1" @click="close_click(2)"
                  style="width: 43px;height: 43px;position: absolute;left: 750px;top: 50px"/>

        <div style="display: flex;width: 100%;height: 40px;justify-content: space-between;margin-bottom: 12px">
          <div style="display: flex;padding-top: 4px">
<!--            <div :class="tabindex4 === 1?'part_font_click':'part_font'" style="margin-left: 45px" @click="click_more_details(1)">-->
<!--              体验区-->
<!--              <div v-if="tabindex4 === 1" class="tar-line" style="width: 100%;"></div>-->
<!--            </div>-->
<!--            <div :class="tabindex4 === 2?'part_font_click':'part_font'" style="margin-left: 45px"   @click="click_more_details(2)">-->
<!--              信用卡福利区-->
<!--              <div v-if="tabindex4 === 2" class="tar-line" style="width: 100%;"></div>-->
<!--            </div>-->
<!--            <div :class="tabindex4 === 3?'part_font_click':'part_font'" style="margin-left: 45px" @click="click_more_details(3)">-->
<!--              储蓄卡福利区-->
<!--              <div v-if="tabindex4 === 3" class="tar-line" style="width: 100%;"></div>-->
<!--            </div>-->
          </div>
          <div style="display: flex;margin-right: 18px">
            <div class="box_part8" @click="pre_page1">
              上一页
            </div>
            <div class="box_part8" @click="next_page1">
              下一页
            </div>
          </div>
        </div>

        <div class="box_part10">
          <div style="display: flex">
            <div style="width: 100%;display: flex;flex-wrap: wrap;margin-top: 10px;">
              <div v-for="item in ticket_list4.rows">
                <div class="content4" @click="lijian_click(item, 3)" v-if="mti_type==3">
                  <div style="display: flex;padding:7px;">
                    <div :style="{'margin-top': item.bmi_mer_pb_path?'-20px' : '0px'}">
                      <div class="img_mask">
                        <el-image v-if="item.bmi_mer_pb_path" style="width: 18px;  height: 18px;" :src='item.bmi_mer_pb_path'/>
                        <span style="font-size: 11px;line-height: 18px;">{{item.bmi_mer_pb}}</span>
                      </div>
                      <el-image style="width: 100px;height: 100px;" :src='item.mti_img_path'/>
                      <div v-if="item.bjSigns.length>0" class="sign_mask">
                        <div v-for="(tag,index) in item.bjSigns" :key="index" style="font-size: 11px; color:#ffffff;" v-if="index < 2">
                          {{ tag.tsi_name }}
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;flex-direction: column;justify-content: space-between;width:195px;height: 110px;">
                      <div
                        style="font-size: 20px;font-weight: bold;color: #333333;line-height: 20px;text-align: left;margin: 8px 5px 5px 5px">
                        {{item.mti_name.length > 11 ? item.mti_name.substring(0,10) + '..': item.mti_name}}
                      </div>
                      <div v-if="item.otherSigns.length>0" style="display: flex;flex-wrap: wrap;">
                        <div v-for="(tag,index) in item.otherSigns" :key="index" style="font-size: 12px; border-radius: 4px;color:red;
                           border: 1px solid red;display: flex;padding: 2px 4px;margin-top: 5px; margin-left: 3px;margin-right: 2px;">
                          {{ tag.tsi_name }}
                        </div>
                      </div>
                      <div style="display: flex;font-size: 17px;font-weight: bold;margin-left: 5px;margin-bottom: 10px;height: 22px;line-height: 22px;">
                        <div style="color: #E02E24;margin-right: 5px;">
                          <span style="font-size: 12px;">￥</span>{{ item.mti_money_2 }}
                        </div>
                        <div style="font-size: 14px;">
                          <span style="font-size: 12px;">￥</span><span style="text-decoration: line-through;">{{ item.mti_money_1 }}</span>
                        </div>

                      </div>
                    </div>

                    <el-image :src="xuxian" style="width: 2px;height: 80px;margin: 10px 0"/>
                    <div
                      style="height: 100%;width: 90px;display: flex;flex-direction: column;align-items: center;">
                      <div style="font-size: 22px;font-weight: bold;">立减</div>
                      <div
                        style="font-size: 26px;font-weight: bold;color: #E02E24;">
                        {{ item.mti_lijian }}<span style="font-size: 18px">元</span></div>
                      <div class="ling">
                        <div style="color: white;font-size: 13px">
                          立即领
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="content2-c"  @click="lijian_click(item, 4)">
                  <div class="trapezoid-down-transform">{{ item.bii_name }}</div>
                  <div class="manjianqu_title_home">
                    <el-image :src="item.bmi_mer_icon?item.bmi_mer_icon:moren"
                              style="width: 15px;height: 15px;border-radius: 15px;"/>
                    {{item.bmi_mer_name.length > 6 ? item.bmi_mer_name.substring(0,5) + '...': item.bmi_mer_name}}
                  </div>
                  <div class="manjianqu_bq_home">
                    <div v-for="(tag,index) in item.signs" :key="index" style="font-size: 10px; border-radius: 4px;color:red;
                           border: 1px solid red;display: flex;padding: 2px 4px;"  v-if="index < 2">
                      {{ tag.tsi_name }}
                    </div>
                    <!--                    <div class="manjianqu_bq_div" v-for="(tag,index) in item.signs" :key="index"  v-if="index < 2">-->
                    <!--                      {{ tag.tsi_name }}-->
                    <!--                    </div>-->
                  </div>
                  <div style="width: 100%;font-size: 40px;font-weight: bold;color: #E02E24;display: flex;justify-content: center;align-items: flex-start;">
                    <span>{{ parseInt(item.mti_money_2) }}</span><span style="font-size: 24px;margin-top: 20px;">元</span>
                  </div>

                  <div
                    style="width: 100%;font-size: 18px;margin-top: -10px;margin-bottom: 40px;">
                    满{{ parseInt(item.mti_money_1) }}即用
                  </div>
                  <div class="manjianqu_btn">
                    <el-image :src='manjian_btn'/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 联系银行按钮弹窗 -->
    <div class="dialog" v-if="lxyinhang_dialog_show">

      <div class="dialog_box1">
        <div style="display: flex;margin: 15px 0 0 25px;">
          <div
            style="font-size: 40px;font-weight: bold;color: #444444;width: 720px;text-align: left;margin-top: 5px">
            查找银行
          </div>
          <div>
            <el-image :src="close1" @click="close_click" style="width: 43px;height: 43px;margin-top: 15px"/>
          </div>
        </div>
        <div style="display: flex;margin-top: 25px;margin-left: 30px;">
          <el-button id="button1" type="primary"
                     style="width: 140px;border-radius: 10px;font-size: 26px;background-color: #096FB8"
                     @click="kefu_click">官方客服
          </el-button>
          <el-button id="button2" type="primary" style="width: 140px;font-size: 26px;border-radius: 10px"
                     @click="zhanghao_click">官方账号
          </el-button>
          <el-button id="button3" type="primary" style="width: 140px;font-size: 26px;border-radius: 10px"
                     @click="bank_click">手机银行
          </el-button>
          <el-button id="button4" type="primary" style="width: 140px;font-size: 26px;border-radius: 10px"
                     @click="wangdian_click">联系网点
          </el-button>
        </div>

        <div class="box_part4">
          <div v-if="yinhang_dialog_flag === 1">
            <div style="height: 980px">
              <div v-for="(item,index) in kefu_data_list.rows">
                <!--                <div v-if="item.tbcs_visible === 1">-->
                <div style="display: flex;margin-left: 42px;padding-top: 25px;">
                  <el-image :src="tiao" style="width: 5px;height: 26px;margin-right: 5px;margin-top: 5px"/>
                  <div style="font-size: 24px;font-weight: bold;color: #000000;">
                    {{ item.tbcs_name }}
                  </div>
                </div>
                <div
                  style="font-size: 18px;font-weight: bold;color: #000000;text-align: left;margin-left: 51px">
                  {{ item.tbcs_phone }}
                </div>
                <div class="box_part6">
                  {{ item.tbcs_content }}
                </div>
                <!--                </div>-->
              </div>
            </div>
            <!--
            <div>
              <el-button-group style="display: flex;justify-content: space-between;width: 780px">
                <el-button type="primary" style="width: 150px;height: 50px;font-size: 20px" @click="prePage">上一页
                </el-button>
                <el-button type="primary" style="width: 150px;height: 50px;font-size: 20px" @click="nextPage">下一页
                </el-button>
              </el-button-group>
            </div>
            -->
          </div>
          <div v-if="yinhang_dialog_flag === 2">
            <div style="display: flex;margin-left: 42px;padding-top: 20px">
              <el-image :src="tiao" style="width: 5px;height: 25px;margin-right: 5px;margin-top: 7px"/>
              <div style="font-size: 24px;font-weight: bold;color: #000000;">微信公众号
              </div>
            </div>
            <div style="display: flex;margin-left: 10px">
              <div v-for="(item,index) in wxaccount_data_list.rows">
                <div v-if="item.tbo_type === 1"
                     style="display: flex;flex-direction: column;width: 150px;height: 400px;margin-left: 32px;margin-top: 15px">
                  <el-image v-if="item.tbo_img_path" :src="item.tbo_img_path" style="width: 150px;height: 150px;margin-bottom: 3px"/>
                  <div
                    style="font-size: 18px;margin-top: 3px;font-weight: bold;color: #000000;height: 50px;">
                    {{ item.tbo_name }}
                  </div>
                  <div class="box_part7">
                    {{ item.tbo_content }}
                  </div>
                </div>
              </div>
            </div>

            <div style="display: flex;margin-left: 42px;padding-top: 30px">
              <el-image :src="tiao" style="width: 5px;height: 25px;margin-right: 5px;margin-top: 7px"/>
              <div style="font-size: 24px;font-weight: bold;color: #000000;">其他官方账号
              </div>
            </div>
            <div style="display: flex;margin-left: 10px">
              <div v-for="(item,index) in wxaccount_data_list.rows">
                <div v-if="item.tbo_type === 2"
                     style="display: flex;flex-direction: column;width: 150px;margin-left: 32px;margin-top: 15px">
                  <el-image v-if="item.tbo_img_path" :src="item.tbo_img_path" style="width: 150px;height: 150px;margin-bottom: 3px"/>
                  <div
                    style="font-size: 18px;margin-top: 3px;font-weight: bold;color: #000000;height: 50px;">
                    {{ item.tbo_name }}
                  </div>
                  <div class="box_part7">
                    {{ item.tbo_content }}
                  </div>
                </div>
              </div>
            </div>
            <!--
            <div>
              <el-button-group style="display: flex;justify-content: space-between;width: 780px">
                <el-button type="primary" style="width: 150px;height: 50px;font-size: 20px" @click="prePage">上一页
                </el-button>
                <el-button type="primary" style="width: 150px;height: 50px;font-size: 20px" @click="nextPage">下一页
                </el-button>
              </el-button-group>
            </div>
            -->
          </div>
          <div v-if="yinhang_dialog_flag === 3">
            <div style="display: flex;margin-left: 42px;padding-top: 25px">
              <el-image :src="tiao" style="width: 5px;height: 25px;margin-right: 5px;margin-top: 7px"/>
              <div style="font-size: 24px;font-weight: bold;color: #000000;">
                手机银行服务介绍
              </div>
            </div>
            <div class="box_part5">
              {{ sjbank_data.tbc_content }}
            </div>
            <div style="display: flex;width: 100%;justify-content: center">
              <div v-if="sjbank_data.tbc_img_apple_path !== ''"
                   style="display: flex;flex-direction: column;margin: 20px 15px 0 15px">
                <div
                  style="font-size: 16px;font-weight: bold;color: #000000;margin-bottom: 3px">
                  {{ sjbank_data.tbc_img_apple_name }}
                </div>
                <el-image v-if="sjbank_data.tbc_img_apple_path" :src="sjbank_data.tbc_img_apple_path" style="width: 185px;height: 185px"/>
              </div>
              <div v-if="sjbank_data.tbc_img_android_path !== ''"
                   style="display: flex;flex-direction: column;margin: 20px 15px 0 15px">
                <div
                  style="font-size: 16px;font-weight: bold;color: #000000;margin-bottom: 3px">
                  {{ sjbank_data.tbc_img_android_name }}
                </div>
                <el-image v-if="sjbank_data.tbc_img_android_path" :src="sjbank_data.tbc_img_android_path" style="width: 185px;height: 185px"/>
              </div>
              <div v-if="sjbank_data.tbc_img_hm_path !== ''"
                   style="display: flex;flex-direction: column;margin: 20px 15px 0 15px">
                <div
                  style="font-size: 16px;font-weight: bold;color: #000000;margin-bottom: 3px">
                  {{ sjbank_data.tbc_img_hm_name }}
                </div>
                <el-image v-if="sjbank_data.tbc_img_hm_path" :src="sjbank_data.tbc_img_hm_path" style="width: 185px;height: 185px"/>
              </div>
            </div>
          </div>
          <div v-if="yinhang_dialog_flag === 4">
            <div style="display: flex;justify-content: space-between">
              <div
                style="margin-top: 15px;margin-left: 25px;font-size: 16px;font-weight: bold;color: #404040;">
                按区筛选
                <el-select v-model="stationAreasOption" placeholder="" size="small" @change="area_change"
                           style="width: 120px;margin-left: 2px">
                  <el-option
                    value=""
                    label="全部">
                  </el-option>
                  <el-option
                    v-for="item in station_areas_options"
                    :key="item.tbsc_area"
                    :value="item.tbsc_area"
                    :label="item.tbsc_area">
                  </el-option>
                </el-select>
              </div>
              <div style="display: flex;margin-right: 8px">
                <div class="box_part8" @click="first_page">
                  首页
                </div>
                <div class="box_part8" @click="pre_page">
                  上一页
                </div>
                <div class="box_part8" @click="next_page">
                  下一页
                </div>
              </div>
            </div>
            <div style="margin-left: 10px;margin-top: 10px;width: 750px;">
              <el-table :data="stationTableData.rows"
                        stripe

                        :cell-style="{ textAlign: 'center' }"
                        :header-cell-style='tableHeaderStyle'>
                <el-table-column prop="tbsc_num" label="序号" width="50px"/>
                <el-table-column prop="tbsc_area" label="区域" width="60px"/>
                <el-table-column prop="tbsc_name" label="网点名称"/>
                <el-table-column prop="tbsc_address" label="地址"/>
                <el-table-column prop="tbsc_phone" label="联系电话" width="70px"/>
                <el-table-column prop="tbsc_area" label="营业时间">
                  <el-table-column label="时令" width="50px">
                    <div style="border-bottom: 1px solid #EBEEF5;padding-bottom: 15%">冬</div>
                    <div style="padding-top: 15%">夏</div>
                  </el-table-column>
                  <el-table-column label="周一至周五" width="85px">
                    <template v-slot="scope">
                      <div style="border-bottom: 1px solid #EBEEF5;padding-bottom: 7%;">{{
                          scope.row.tbsc_business_d
                        }}
                      </div>
                      <div style="padding-top: 7%">{{ scope.row.tbsc_business_x }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="周六" width="85px">
                    <template v-slot="scope">
                      <div style="border-bottom: 1px solid #EBEEF5;padding-bottom: 7%">{{
                          scope.row.tbsc_business_d6
                        }}
                      </div>
                      <div style="padding-top: 7%">{{ scope.row.tbsc_business_x6 }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="周日" width="85px">
                    <template v-slot="scope">
                      <div style="border-bottom: 1px solid #EBEEF5;padding-bottom: 7%">{{
                          scope.row.tbsc_business_d7
                        }}
                      </div>
                      <div style="padding-top: 7%">{{ scope.row.tbsc_business_x7 }}</div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column prop="tbsc_remark" label="备注"/>
              </el-table>
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="dialog1" v-if="zizhi_dialog">
      <el-image :src="close1" @click="close_click1"
                style="width: 43px;height: 43px;position: absolute;left: 540px;top: 20px"/>
      <el-image style="width: 450px;height: 200px;margin-top: 50px" :src="manjian_data.bmi_business_license?manjian_data.bmi_business_license:moren"/>
    </div>


    <div>
      <!--抽福袋攻略弹窗-->
<!--      <div style="position: absolute;bottom: 500px;left: 60px;width: 950px;height: 600px;z-index: 100"-->
<!--           v-show="cfd_show">-->
<!--        <div class="zzc_box"></div>-->
<!--        <div style="width: 40px;height: 40px;position: absolute;z-index: 1000;right: 35px;top: 35px;"-->
<!--             @click='cfd_show=false'></div>-->
<!--        <el-image style="width: 950px;" :src="cfd"/>-->
<!--      </div>-->
<!--      &lt;!&ndash;微信扫码攻略弹窗&ndash;&gt;-->
<!--      <div style="position: absolute;bottom: 500px;left: 60px;width: 950px;height: 600px;z-index: 100"-->
<!--           v-show="wxsm_show">-->
<!--        <div class="zzc_box"></div>-->
<!--        <div style="width: 40px;height: 40px;position: absolute;z-index: 1000;right: 35px;top: 35px;"-->
<!--             @click='wxsm_show=false'></div>-->
<!--        <el-image style="width: 950px;" :src="wxsm"/>-->
<!--      </div>-->
<!--      &lt;!&ndash;移动支付攻略弹窗&ndash;&gt;-->
<!--      <div style="position: absolute;bottom: 500px;left: 60px;width: 950px;height: 600px;z-index: 100"-->
<!--           v-show="ydzf_show">-->
<!--        <div class="zzc_box"></div>-->
<!--        <div style="width: 40px;height: 40px;position: absolute;z-index: 1000;right: 35px;top: 35px;"-->
<!--             @click='ydzf_show=false'></div>-->
<!--        <el-image style="width: 950px;" :src="ydzf"/>-->
<!--      </div>-->
      <!--抽福袋弹窗-->

      <!--移动支付便民示范工程弹窗-->
      <!--支付成功页面-->
        <div class="dialog" v-if="payment_show_success">
          <div class="dialog_msg">
            <div style="margin-top: 50px;width: 100%;"></div>
            <el-image v-if="showtype == 2" :src="close1" @click="window_close_all()"
                      style="width: 95px;height: 95px;position: absolute;left: 750px;top: -150px"/>
            <div>
              <div style="width:100%;display: flex;justify-content:center;font-size: 55px;color: #FFFFFF; margin-top: 20px;">
                <el-image style="width: 414px;height:456px;" :src="showtype == 2?chuhuo:chuhuozhong"/>
                <span v-if="showtype == 2">贵宾请在下方取物口<br> 取走您的宝贝</span>
                <span v-else>贵宾请稍候。。。<br> 您的宝贝马上就到位</span>
              </div>
            </div>
          </div>
      </div>
      <!--支付失败页面-->
      <div class="dialog" v-if="payment_show_fail">
        <div class="dialog_msg_fail">
          <div style="display: flex;justify-content: flex-end;">
            <el-image :src="close1" @click="window_close_all()"
                      style="width: 95px;height: 95px;margin-top: 15px;margin-right: 15px;"/>
          </div>
            <div style="width:100%;display: flex;font-size: 30px;color: #000000;font-weight: bold;justify-content: center;">
              <el-image style="width: 234px;height:356px;" :src="showtype == 0?chuhuono:chuhuofail"/>
              <div style="display: flex;flex-direction: column;margin-left: 20px;">
                <span v-if="showtype == 0" style="text-align: left;">贵宾抱歉!<br>由于您没有使用<span style="color: #1491D2">{{ bankName }}手机银行</span>支付<br>无法为您奉上宝贝<br>请微信扫码联系客服姐姐退款<br><br></span>
                <span v-else style="text-align: left;">贵宾抱歉!<br>我好像出故障了 <br>请微信扫码联系客服姐姐退款<br><br></span>
                <el-image style="width: 188px;height:188px;margin-top:5px;" :src="cs"/>
              </div>
            </div>

          </div>
        </div>
      </div>

    <!--支付失败页面-->
    <div class="dialog" v-if="zxbzDialog">
      <div class="dialog_zxbz">
        <el-image :src="close1" @click="zxbz_close"
                  style="width: 87px;height: 87px;position: absolute;left: 670px;top: 25px;z-index: 999;"/>
        <el-image  src="https://go.borunxinke.com/fr/imgserver/admin/zxbz.png"/>
      </div>
    </div>

      <!--商品二维码页面-->
      <div class="dialog" v-if="qr_code_show">
        <div class="dialog_box">
          <div
            style="font-size: 57px;color: #76510D;margin-top: 20px;width: 100%;font-weight: bold">
            便利惠
          </div>
          <el-image style="width: 162px;height: 32px;" :src='shop_title'/>
          <el-image :src="close1" @click="window_close_all()"
                    style="width: 43px;height: 43px;position: absolute;left: 750px;top: 50px"/>
          <div class="box_part9">
            <div style="display: flex;flex-direction: column;">
              <!--商品详情-->
              <div style="display: flex;">
                <div style="margin: 44px 52px;">
                  <el-image style="width: 174px;height: 174px;" v-if="objMsg.mbgi_goods_img_path" :src='objMsg.mbgi_goods_img_path'/>
                </div>

                <div class="box_shop">
                  <div style="font-weight: bold;">
                    {{ objMsg.mbgi_goods_name }}
                  </div>
                  <div>
<!--                    规格数量：{{ objMsg.mbgi_goods_describer + '*' + objMsg.count_num }}-->
                    规格数量：{{ objMsg.mbgi_goods_describer }}
                  </div>
                  <div>
                    门市价：<span style="font-size: 18px">￥</span><span style="text-decoration: line-through;">{{ objMsg.mbgi_money_1 }}</span>
                  </div>
                  <div>
                    福利价：<span style="font-size: 18px">￥</span>{{ objMsg.mbgi_money_2 }}
                  </div>
                  <div>
                    手机银行专享价：<span style="font-size: 18px">￥</span><span style="color:#a10900;">{{ objMsg.mbgi_money_3 }}</span>
                  </div>
                </div>
              </div>
              <!-- 中间按钮-->
              <div style="display: flex;justify-content: space-between;padding:0px 20px;">
                <div :class="shop_btn_index===2?'shop_btn_click':'shop_btn'" @click="commodity_qc_code(2)">
                  <div>福利价</div>
                  <div><span style="font-size: 18px">￥</span><span style="font-size: 30px;">{{ objMsg.mbgi_money_2 }}</span></div>
                  <div style="display: flex;justify-content: space-between; padding: 0px 20px;width:100%;">
                    <el-image style="width: 21px;height: 21px;" :src='wx_s'/>
                    <el-image style="width: 21px;height: 21px;" :src='zfb_s'/>
                    <el-image style="width: 21px;height: 21px;" :src='ysf_s'/>
                  </div>
                </div>
                <div :class="shop_btn_index===3?'shop_btn_click':'shop_btn'"  @click="commodity_qc_code(3)">
                  <div>手机银行专享价</div>
                  <div style="display: flex;"><el-image style="width: 31px;height: 31px;margin-top:5px;" :src='bankIcon'/>
                    <span style="font-size: 18px;margin-top:10px;">￥</span><span style="font-size: 30px;">{{ objMsg.mbgi_money_3 }}</span>
                  </div>
                  <div style="display: flex;justify-content: space-between; padding: 0px 20px;width:100%;height: 21px;"></div>
                </div>
                <el-image style="width: 140px;height: 96px;" :src='szqb' @click="jqqd"/>
                <el-image style="width: 140px;height: 96px;" :src='jfdh' @click="jqqd"/>
                <el-image style="width: 140px;height: 96px;" :src='qyqdh' @click="jqqd"/>
              </div>
              <div style="display: flex;justify-content: space-between;padding:0px 20px;margin-top:5px;">
                <div class="shop_bg" ><div :class="shop_btn_index===2?'shop_bg_click':'shop_bg'" ></div></div>
                <div class="shop_bg" ><div :class="shop_btn_index===3?'shop_bg_click':'shop_bg'" ></div></div>
                <div class="shop_bg" ></div>
                <div class="shop_bg" ></div>
                <div class="shop_bg" ></div>
              </div>
              <!--温馨提示-->
              <div v-if="wxts_view" class="wxts_bg">
                <el-image style="width: 145px;height: 43px;margin-top:-20px;" :src="wxts"></el-image>
                <div style="font-size: 22px;justify-content: center;display: flex;font-weight: bold;width:90%;">
                  <span> 为确保顺利出货，请您务必使用<span style="color: #1491D2;">{{ bankName }}手机银行APP</span>扫码支付<br></span>
                </div>
                <div class="wxts_btn" @click="wxtsClick">知道了</div>
              </div>
              <!-- 生成支付二维码 -->
              <div  style="display: flex;flex-direction: column;align-items: center;">
                <div style="width: 680px;height:302px;border: 4px solid #acacac;border-radius: 10px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                  <div  style="font-size: 23px;">倒计时：{{this.timer_second}}s</div>
                  <vue-qr style="width: 180px;height: 180px;margin-top: 8px;" :text="img_commodity.msg" :margin="0" :logoScale="0.3"
                          :size="200"></vue-qr>
                  <div style="margin-top:11px;font-size: 27px;color: #e02e24">{{shop_btn_index===2?objMsg.mbgi_money_2:objMsg.mbgi_money_3}}元</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  活动券列表弹窗  -->
      <div style="position: absolute;top: 400px;left: 70px;width: 950px;height: 1200px;z-index: 201"
           v-show="ticket_list_show">
        <div class="zzc_box"></div>
        <el-image style="width: 950px;height: 1200px" :src="back1"></el-image>
        <el-image style="width: 60px;height: 60px;position: absolute;top: 50px;right: 35px;"
                  :src="activity_background_close" @click="close_ticket_list"/>

        <div style="z-index: 200;position: absolute;top: 40px;right: 90px;width: 770px;">
          <div
            style="display: flex;justify-content: flex-start;color: white;font-size: 65px;width: 300px;height: 100px;">
            <p>{{ ticket_list.rows.ttd_name }}</p>
          </div>
          <div
            style="display: flex;justify-content: flex-start;color: black;font-size: 27px;font-weight:bold;width: 200px;height: 50px;margin-top: 20px;line-height: 50px">
            <el-image :src="jiantou" style="width: 50px;height: 50px"></el-image>
            <p style="margin: 0;height: 50px">参与说明</p>
          </div>
          <div
            style="display: flex;text-align: start;padding-left: 50px;width: 780px;font-size: 20px;white-space: pre-wrap">
            {{ ticket_list.rows.bti_note }}
          </div>
          <div style="display: flex;justify-content: space-between">
            <div
              style="display: flex;justify-content: flex-start;color: black;font-size: 27px;font-weight:bold;width: 200px;height: 60px;line-height: 50px">
              <el-image :src="jiantou" style="width: 50px;height: 50px"></el-image>
              <p>{{ ticket_list.rows.ttd_name }}表</p>
            </div>
            <div>
              <div v-if="this.ticket_activity_time === '1'"
                   style="font-size: 22px;font-weight: bold;color: red;line-height: 50px">
                距离活动开始还剩：{{ this.residue_hour }} 小时 {{ this.residue_minutes }} 分 {{ this.residue_seconds }} 秒
              </div>
              <div v-else-if="this.ticket_activity_time === '2'"
                   style="font-size: 22px;font-weight: bold;color: red;line-height: 50px">
                今日活动已结束,明天再来看看吧
              </div>
              <div v-else-if="this.ticket_activity_time === '3'"
                   style="font-size: 22px;font-weight: bold;color: red;line-height: 50px">
                距离活动结束还剩：{{ this.residue_hour }} 小时 {{ this.residue_minutes }} 分 {{ this.residue_seconds }} 秒
              </div>
            </div>
          </div>

          <div style="position: relative;width: 100%">
            <div style="height: 380px;display: flex;flex-wrap: wrap;justify-content: space-between">
              <div v-for="(item,index) in this.mer_ticket_list.rows" :key="index">
                <div style="position: relative" @click="ticket_detail(item)">
                  <el-image style="width: 355px;height: 190px;flex-wrap: wrap;margin-top: 20px" :src="item.mti_img_path"
                            fit="cover"></el-image>
                  <div
                    style="display: flex;line-height: 40px;position: absolute;z-index: 1;justify-content: space-between;bottom: 7px;height: 40px;width: 100%;background-color: rgba(255,255,255,0.8)">
                    <div style="font-size: 18px;font-weight: bold">{{ item.mti_name }}</div>
                    <div>原价:{{ item.mti_money_1 }} &nbsp; 秒杀价: <span
                      style="color: red;font-size: 20px;font-weight: bold">{{ item.mti_money_2 }}</span></div>
                  </div>
                </div>
                <div style="text-align: left;font-size: 14px;font-weight: bold;">
                  本轮剩余: {{ item.ticket_pool_count }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="position: absolute;bottom: 40px">
          <el-button-group style="display: flex;justify-content: space-between;width: 950px">
            <el-button
              style="background-color: rgb(253,169,87);width: 150px;height: 60px;border: #ff4d51 1px solid;font-size: 20px"
              @click="prePage">上一页
            </el-button>
            <el-button
              style="background-color: rgb(253,169,87);width: 150px;height: 60px;border: #ff4d51 1px solid;font-size: 20px"
              @click="nextPage">下一页
            </el-button>
          </el-button-group>
        </div>
      </div>

      <!--  详情弹窗  -->
      <div style="position: relative">

      </div>
      <div style="position: absolute;top: 560px;left: 70px;width: 950px;height: auto;z-index: 201"
           v-show="show_ticket_detail">
        <div class="zzc_box"></div>
        <el-image style="width: 950px;height: 1000px;" :src="back1"></el-image>
        <el-button style="width: 120px;height: 50px;position: absolute;top: 50px;right: 800px;font-size: 16px"
                   @click="close_ticket_detail">
          返回上一页
        </el-button>

        <div style="position:absolute;top: 100px;left: 50px;display: flex">
          <el-image style="width: 355px;height: 190px;flex-wrap: wrap;margin-top: 50px;margin-left: 50px"
                    v-if="ticket_detail_rows.mti_img_path" :src="ticket_detail_rows.mti_img_path" fit="cover"></el-image>
          <div
            style="height: 190px;margin-top: 50px;width: 270px;display: flex;flex-direction: column;text-align: left;padding-left: 80px">
            <div style="font-size: 24px;font-weight: bold;padding-top: 15px">{{
                this.ticket_detail_rows.mti_name
              }}
            </div>
            <div style="font-size: 22px;font-weight: bold;padding-top: 25px;">原价: <span
              style="text-decoration: line-through">{{ this.ticket_detail_rows.mti_money_1 }}</span></div>
            <div style="font-size: 22px;font-weight: bold;padding-top: 15px">秒杀价: <span
              style="color: red;font-size: 34px">{{ this.ticket_detail_rows.mti_money_2 }}</span></div>
          </div>
        </div>

        <div
          style="display: flex;flex-direction: column;width: 510px;height: 500px;left: 100px;position: absolute;top: 400px;border-right: 2px rgba(204,204,204,.5) solid">
          <div style="display: flex">
            <el-image :src="jiantou" style="width: 50px;height: 50px"></el-image>
            <p style="margin-bottom: 15px;height: 50px;font-size: 22px;font-weight: bold;line-height: 50px">优惠详情</p>
          </div>
          <div style="display: flex;flex-direction: column;text-align: left">
            <p style="margin-bottom: 5px">【商品详情】</p>
            <p style="padding-left: 9px;padding-right: 9px;margin-bottom: 5px;white-space: pre-wrap;font-size: 18px">
              {{ this.ticket_detail_rows.mti_note }}</p>
            <p style="margin-bottom: 5px">【领券方式】</p>
            <p style="padding-left: 9px;white-space: pre-wrap;margin-bottom: 5px;font-size: 18px">
              微信扫描右侧二维码进入“领券吧”小程序领取</p>
            <p style="margin-bottom: 5px">【用券方式】</p>
            <p style="padding-left: 9px;white-space: pre-wrap;margin-bottom: 5px;font-size: 18px">打开[领券吧]小程序，路径:
              我的-我的优惠券，打开要使用的券，出示给商家收银员进行核销，现场支付秒杀券金额。</p>
          </div>

          <div style="display: flex;padding-top: 10px">
            <el-image :src="jiantou" style="width: 50px;height: 50px"></el-image>
            <p style="margin-bottom: 15px;height: 50px;font-size: 22px;font-weight: bold;line-height: 50px">适用门店</p>
          </div>
          <div style="display: flex;flex-direction: column;text-align: left;padding-left: 10px">
            <div v-for="(item,index) in use_shop_list" :key="index">
              <div v-if="item.isSelect === 1">
                <div style="font-size: 16px;">
                  {{ item.bmst_name }}
                </div>
                <div style="font-size: 14px;">
                  {{ item.bmst_address }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="position: absolute;top: 420px;right: 90px">
          <el-image style="width: 180px;height: 180px;margin-top: 50px;margin-left: 50px"
                    v-if="ticket_detail_rows.mti_code_img_path" :src="ticket_detail_rows.mti_code_img_path" fit="fill"></el-image>
          <p style="margin-left: 50px;font-size: 26px;font-weight: bold">微信扫码领券</p>
          <p style="margin-left: 50px;font-size: 17px;font-weight: bold;color: red">凭券到店可享秒杀价</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {Image} from 'element-ui'
import SVGA from "svgaplayerweb"
// import Keyboard from 'simple-keyboard'
// import 'simple-keyboard/build/css/index.css'
import Vue from 'vue'
import vueQr from 'vue-qr'
import es6 from '@/assets/js/custom_es6.js'
import lottie from 'lottie-web' // 引入插件
import animationData from '@/assets/js/8362-lottery-whirl.json' // 引入json 数据
// import VideoPlayer from 'vue-video'
// import CoreVideoPlayer from 'vue-core-video-player'

export default {
  components: {
    vueQr,
    // CoreVideoPlayer,
    [Image.name]: Image
  },
  name: 'defaultIndex',
  props: {
    pri_detail: {
      type: Object,
      default: function () {
        return {
          activityObj: {},
        }
      },
    },
  },

  computed: {
    getImageUrl () {
      return (imageName) => require(`@/assets/images/${imageName}`)
    }
  },

  data () {
    return {
      imageList: [
        {'image_path': require('@/assets/images/xkzx.png'), 'name': '新客惊喜', 'type': 'xkzxOpen'},
        {'image_path': require('@/assets/images/xinke.png'), 'name': '全行活动', 'type': 'qhhdOpen'},
        // {'image_path': require('@/assets/images/xinke.png'), 'name': '全行活动', 'type': 'hdzq'},原银行活动
        {'image_path': require('@/assets/images/daikuan.png'), 'name': '金融产品甄选区', 'type': 'jrcs'},
        {'image_path': require('@/assets/images/xlh.png'), 'name': '限量惠', 'type': 'hdzq'},
        {'image_path': require('@/assets/images/yinhang.png'), 'name': '查找银行', 'type': 'yinhang_click'},
        {'image_path': require('@/assets/images/hzqt.png'), 'name': '合作报名', 'type': 'hzsjOpen'},
        {'image_path': require('@/assets/images/zixun.png'), 'name': '客服中心', 'type': 'bfrxOpen'},
        // {'image_path': require('@/assets/images/daikuan.png'), 'name': '金融产品甄选区', 'type': 'bfrxOpen'}
        // {'image_path': require('@/assets/images/yinhang.png'), 'name': '新客惊喜', 'type': 'xkzxOpen'}
      ],
      // bgImg: '@/assets/images/ga6',
      bgImg:'https://pre.borunxinke.com:1443//fr/imgserver/ga6.svga',
      hzbmItem: {},
      visibleItems: [],
      goodsItems: [],
      quanItems: [],
      lquanItems: [],
      startIndex: 0,
      imageListLength: 0,
      goodsListLength: 0,
      quanListLength: 0,
      lquanListLength: 0,
      reloadTime: 0,
      isVisible: true,
      svgaVisible: true,
      carouseInterval: 0,
      quanInterval: 0,
      lquanInterval: 0,
      goodsInterval: 0,
      goods_timer: '',
      quan_timer: '',
      lquan_timer: '',
      interval: 15000,
      initialIndex: 0,
      curIndex: 0,
      autoplay: true,
      isPlay: false,//播放状态
      isIn: false,//鼠标是否位于播放器内
      nowIndex: 0,
      videos: [
        {id: '1', name: 'videos1', src: 'https://pre.borunxinke.com:1443//fr/imgserver/video.mp4'},
        {id: '2', name: 'videos2', src: 'https://pre.borunxinke.com:1443//fr/imgserver/test.mp4'}
      ],
      videoUrl: '',
      index: -1,
      options1: {
        controls: true,
        sources: [
          // 视频源 URL
          {src: 'https://pre.borunxinke.com:1443//fr/imgserver/video.mp4', type: 'video/mp4'},
        ],
      },
      options2: {
        controls: true,
        sources: [
          // 视频源 URL
          {src: 'https://pre.borunxinke.com:1443//fr/imgserver/test.mp4', type: 'video/mp4'},
        ],
      },
      playerOptions: {
        sources: [{
          src: 'https://pre.borunxinke.com:1443//fr/imgserver/video.mp4',
          type: 'video/mp4'
        }],
        autoplay: false,
        controls: true
      },
      audios: {},
      pageShow: false,
      timer_new: '',
      window_timer: '', // 弹窗倒计时
      commodity_data1: [],
      cfd_show: false,
      wxsm_show: false,
      ydzf_show: false,
      img_data: [],
      bdbi_path: '',
      bdbi_path_qr: '',
      payment_show_success: false,
      business_data: [],
      business_data1: [],
      tu7: require('@/assets/images/tu7.png'),
      cs: require('@/assets/images/cs.png'),
      activity_background_close: require('@/assets/images/close.png'),
      jiantou: require('@/assets/images/jiantou.png'),
      back1: require('@/assets/images/back1.jpg'),
      moren: require('@/assets/images/tu1.png'),
      yinhang: require('@/assets/images/yinhang.png'),
      xinke: require('@/assets/images/xinke.png'),
      daikuan: require('@/assets/images/daikuan.png'),
      manghe: require('@/assets/images/manghe.png'),
      xkzx: require('@/assets/images/xkzx.png'),
      fljn: require('@/assets/images/fljn.png'),
      hzqt: require('@/assets/images/hzqt.png'),
      yingyin: require('@/assets/images/yingyin.png'),
      xinyuan: require('@/assets/images/xinyuan.png'),
      chaozhi: require('@/assets/images/fuli.png'),
      huipin: require('@/assets/images/huipin.png'),
      nuanxin: require('@/assets/images/nuanxin.png'),
      manjian: require('@/assets/images/manjian.png'),
      lijian: require('@/assets/images/lijian.png'),
      zixun: require('@/assets/images/zixun.png'),
      jiantou1: require('@/assets/images/jiantou1.png'),
      close1: require('@/assets/images/close1.png'),
      xuxian: require('@/assets/images/xuxian.png'),
      xiaochengxu: require('@/assets/images/xiaochengxu.jpg'),
      duigou: require('@/assets/images/duigou.png'),
      weixin: require('@/assets/images/weixin.png'),
      // ma: require('@/assets/images/ma.png'),
      biaoqian: require('@/assets/images/biaoqian.png'),
      dui: require('@/assets/images/dui.png'),
      tiao: require('@/assets/images/tiao.png'),
      chuhuozhong: require('@/assets/images/chuhuozhong.png'),
      chuhuo: require('@/assets/images/chuhuo.png'),
      chuhuono: require('@/assets/images/chuhuono.png'),
      chuhuofail: require('@/assets/images/chuhuofail.png'),
      wxts: require('@/assets/images/wxts.png'),
      szqb: require('@/assets/images/szqb.png'),
      jfdh: require('@/assets/images/jfdh.png'),
      qyqdh: require('@/assets/images/qyqdh.png'),
      ysf_s: require('@/assets/images/ysf_s.png'),
      zfb_s: require('@/assets/images/zfb_s.png'),
      wx_s: require('@/assets/images/wx_s.png'),
      manjian_btn: require('@/assets/images/manjian_btn.png'),
      shop_title: require("@/assets/images/shop_title.png"),
      biaozhu: require('@/assets/images/biaozhu.png'),
      kong: require('@/assets/images/kong.png'),
      kfzx: require('@/assets/images/kfzx.png'),
      hzbm: require('@/assets/images/hzbm.png'),
      tabindex1: 1,
      tabindex2: 5,
      tabindex3: 8,
      tabindex4: 1,
      shop_btn_index: 0,
      wxts_view: false,
      lijian_dialog_show: false,
      lijian_more_show: false,
      bjSigns: [],
      otherSigns: [],
      discount: '',
      manjian_data: {
        perPageSize: 5,
        currentPage: 1,
      },
      manjian_dialog_show: false,
      lxyinhang_dialog_show: false,
      zxbzDialog: false,
      jrcsDialog: false,
      hdzqDialog: false,
      qhhdDialog: false,
      xkzxDialog: false,
      fljnDialog: false,
      yyzzDialog: false,
      hzsjDialog: false,
      bfrxDialog: false,
      tbs_id: '',
      mti_type: 1,
      card_type: 1,
      tbs_type: 1,
      supermarketIndex: 0,
      supermarket: {},
      zizhi_dialog: false,
      bank_id: '',
      yinhang_dialog_flag: 1,
      tbc_img_apple_path: '',
      tbc_img_android_path: '',
      tbc_img_hm_path: '',
      stationTableData: {
        rows: [],
        perPageSize: 7,
        currentPage: 1,
      },
      sjbank_data: {
        tbc_img_apple_path: '',
        tbc_img_android_path: '',
        tbc_img_hm_path: '',
      },
      kefu_data_list: {},
      wxaccount_data_list: {},
      otheraccount_data_list: {},
      station_areas_options: [],
      stationAreasOption: '',
      kfzxList: [],
      twt_img_path: '',
      tcm_img_path: '',
      tlh_img_path: '',
      toq_img_path: '',
      activity_show: false,
      tableData: [],
      supermarketData: [],
      hdzqData: {
        rows: [],
        status: '',
        total: '',
        currentPage: 1,
        perPageSize: 2
      },
      xkzxData: {
        rows: [],
        status: '',
        total: '',
        currentPage: 1,
        perPageSize: 3
      },
      qhhdData: {
        rows: [],
        status: '',
        total: '',
        currentPage: 1,
        perPageSize: 3
      },
      activity_id: false,
      activity_list_show: true,
      activity_phone_show: false,
      activity_prize_show: false,
      activity_prize_show_box: false,
      step1_show: true,
      step2_show: false,
      step3_show: false,
      phone: '',
      phonerule: {
        // phone: [
        //   {required: true, validator: phone, trigger: 'blur'}
        // ],
      },
      opportunity_show: false,
      lai_uuid: '',
      lai_user_scope: '',
      total1: '',
      total2: '',
      tips: '',
      a1: true,
      a2: false,
      lessing_bag1: false,
      lessing_bag2: false,
      pic_item1: [],
      type: '',
      lai_caption: '',
      prize: '',
      count: '', //倒计时
      money: '',
      keyboard: null,
      keyboard1: null,
      keyboardClass: 'simple-keyboard',
      showKeyBoard: false,
      number_tableData: [],
      number: '',
      data_time1: '',
      data_time2: '',
      data_time3: '',
      tableData1: [],
      data_id: '',
      phoneForm: {},
      qr_code_show: false,
      codeShow: true,
      commodity_tableData: [],
      internal_goods_tableData1: [],
      internal_goods_tableData: [],
      internal_goods_data: [],
      transcoding_id: '', //转码
      billNo: '', //订单号
      img_commodity: {
        msg: '',
        billNo: '',
      },
      count1: '',
      timer: null,
      timer1: null,
      ObjData: {},
      objMsg: {},
      mbgi_goods_name: '', //商品名称
      mbgi_money_3: '', //商品特惠价
      mbgi_sale_mode: '', //1设备内，其他设备外
      phone_size1: false, //验证手机号后解锁没机会
      phone_size2: false, //验证手机号后解锁超时
      mau_uuid_new: '', //手机号验证成功取得参数
      cq_code1: false, //二维码
      cq_code2: false, //二维码
      count3: '', //解锁中的时间
      mbs_writetime_new: '', //手机号验证成功取得参数
      count_time: '', //列表定时器
      timer_pay: '',
      payment_show_fail: false, //支付页面开关
      showtype: 0, // 0为非指定银行卡  2出货成功 3 出货失败 5正在出货
      timer_second: 120, // 倒计时
      bankName:'',
      bankIcon:'',
      radioType: '0',
      hdEnable: false,
      checkCode: '',
      act_id: '',
      jihui: 0,
      ticket_list: {
        rows: [],
        status: '',
      },
      ticket_list_show: false,
      show_ticket_detail: false,
      mer_ticket_list: {
        rows: [],
        status: '',
        total: '',
        currentPage: 1,
        perPageSize: 4,
      },
      ticket_activity_time: '',  // 1.未开始 2.已结束 3.进行中
      residue_time: '',          // 距活动开始/结束时间
      residue_hour: '',
      residue_minutes: '',
      residue_seconds: '',
      activity_timer: '',
      ticket_detail_rows: [],
      use_shop_list: [],
      ticket_list2: [],
      ticket_list3: [],
      ticket_list4: {
        total: 0,
        currentPage: 1,
        perPageSize: 12,
      },
    }
  },
  created: function () {

    // Vue.directive('prevent-copy', {
    //   bind(el) {
    //     el.oncopy = e => e.preventDefault()
    //   },
    //   unbind(el) {
    //     el.oncopy = null
    //   }
    // })
    // 禁止右键菜单
    document.oncontextmenu = function () {
      return false
    }
    // 禁止文字选择
    document.onselectstart = function () {
      return false
    }
    // 禁止复制
    document.oncopy = function () {
      return false
    }
    // 禁止剪切
    document.oncut = function () {
      return false
    }
    // 禁止粘贴
    document.onpaste = function () {
      return false
    }

    // this.audio.preload = "auto"
    this.img_select()
    this.qrCodeWeChat()
    this.commodity_list_select()
    this.get_ticket_list2(1)
    this.get_ticket_list3(1)
    this.getSoundPathByCondition()
    // 定时轮训广告信息
    // setInterval(() => {
    //   this.img_select()
    // }, 1000 * 60 * 5)
    setInterval(() => {
      this.img_select()
      this.getSoundPathByCondition()
    }, 1000 * 60 * 60 * 2)
    setInterval(() => {
      this.get_ticket_list2(1)
      this.get_ticket_list3(1)
      this.commodity_list_select()
    }, 1000 * 60 * 10)
    this.img_select1()
    this.bank_commodity() // 转13位银行码
    // this.updateItems()
  },
  watch: {
    qr_code_show (newShow) {
      if (newShow) {
        this.timer_second = 120
        if (this.window_timer) {
          clearInterval(this.window_timer)
        }
        this.window_timer = setInterval(() => {
          if (this.timer_second === 0) {
            this.window_close_all()
          } else {
            this.timer_second--
            if (this.img_commodity.billNo) {
              this.commodity_payment()
            }
            // if (this.img_commodity.billNo && this.timer_second % 2 === 0) {
            //   this.commodity_payment()
            // }
          }
        }, 1000)
      } else {
        if (this.window_timer) {
          clearInterval(this.window_timer)
          this.window_timer = ''
        }
      }
    },
    payment_show_fail (newShow) {
      try {
        if (newShow) {
          this.timer_second = 180
          if (this.window_timer) {
            clearInterval(this.window_timer)
          }
          this.window_timer = setInterval(() => {
            if (this.timer_second === 0) {
              this.window_close_all()
            } else {
              // this.$message({
              //   type: 'info',
              //   message: '倒计时' + this.timer_second,
              // })
              this.timer_second--
            }
          }, 1000)
        } else {
          if (this.window_timer) {
            clearInterval(this.window_timer)
            this.window_timer = ''
          }
        }
      } catch(err) {
        this.$message({
          type: 'info',
          message: '发生错误' + err
        })
      }

    },
    payment_show_success (newShow) {
      if (newShow) {
        this.timer_second = 30
        if (this.window_timer) {
          clearInterval(this.window_timer)
        }
        this.window_timer = setInterval(() => {
          if (this.timer_second === 0) {
            this.window_close_all()
          } else {
            this.timer_second--
          }
        }, 1000)
      } else {
        if (this.window_timer) {
          clearInterval(this.window_timer)
          this.window_timer = ''
        }
      }
    },

    money (input) {
      this.keyboard.setInput(input)
    },
    phone (input, newInput) {
      this.keyboard.setInput(input)
      this.phone = input.length > 11 ? input.slice(0, 11) : input
    },
    checkCode (input, newInput) {
      this.keyboard.setInput(input)
      this.checkCode = input.length > 7 ? input.slice(0, 7) : input
    },

  },
  mounted () {
    // this.setFill()
    // this.$nextTick(() => {
    //   this.SVGA()
    // })
    this.imageListLength = this.imageList.length
    if (this.imageListLength > 6) {
      this.carouseInterval = 10000
    } else {
      this.carouseInterval = 0
    }
    this.updateVisibleItems()
    // this.keyboard = new Keyboard(this.keyboardClass, {
    //   onChange: this.onChange,
    //   onKeyPress: this.onKeyPress,
    // })
    // this.setKeyboard()
    this.optAnimation()
    window['customMethod'] = (val) => {
      this.customMethod(val)
    }
    window['hzsjOpen'] = () => {
      this.hzsjOpen()
    }
    window['bfrxOpen'] = () => {
      this.bfrxOpen()
    }
    window['yyzzOpen'] = () => {
      this.yyzzOpen()
    }
    // this.$refs.bdbiShow.$el.addEventListener('current-change', this.play)
  },
  methods: {
    //监听视频的播放、暂停、播放完毕等事件
    listenVideo () {
      let myVideo = this.$refs['player' + this.nowIndex]
      if (myVideo && myVideo[0].paused) {
        myVideo[0].play()
      }
      // 监听播放
      myVideo[0].addEventListener('play', () => {
        this.autoplay = true
      })
      // 监听暂停
      myVideo[0].addEventListener('pause', () => {
        this.autoplay = true
      })
      // 监听播放完毕
      myVideo[0].addEventListener('ended', () => {
        // 时间归零
        myVideo[0].currentTime = 0
        this.autoplay = true
      })
    },
    //播放视频
    playVideo () {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs['player' + this.nowIndex];
      myVideo[0].play();
    },
    //暂停视频
    pauseVideo () {
      //注意：这样获取的dom是一个数组，必须加上[0]索引才能正确的添加事件
      let myVideo = this.$refs['player' + this.nowIndex];
      myVideo[0].pause();
    },
    guolvStr(str) {
      return str.replace(/^\s+/, "")
    },
    get_ticket_list2 (card_type) {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getTicketsByCityAndType,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
            mti_city_id: this.pri_detail.activityObj.city_id,
            device_id: this.pri_detail.activityObj.di_uuid,
            mti_type: 4,
            card_type: card_type,
            perPageSize: 1000,
            currentPage: 1
          }
        )
      ).then(res => {
        console.log(res)
        for (let i = 0; i < res.data.rows.length; i++) {
          res.data.rows[i].mti_money_1 = parseInt(res.data.rows[i].mti_money_1)
          res.data.rows[i].mti_money_2 = parseInt(res.data.rows[i].mti_money_2)
        }

        this.ticket_list2 = res.data.rows
        this.quanListLength = this.ticket_list2.length
        if (this.quan_timer) {
          clearInterval(this.quan_timer)
        }
        if (this.quanListLength > 6) {
          this.quanInterval = 10000
          this.quan_timer = setInterval(() => {
            this.handleQuanlChange()
          }, this.quanInterval)
        } else {
          this.quanInterval = 0
        }
        this.updateQuanItems()
      }).catch(err => {
        console.log('失败 ' + err)
      })
    },

    get_ticket_list3 (card_type) {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getTicketsByCityAndType,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
            mti_city_id: this.pri_detail.activityObj.city_id,
            device_id: this.pri_detail.activityObj.di_uuid,
            mti_type: 3,
            card_type: card_type,
            perPageSize: 10000,
            currentPage: 1
          }
        )
      ).then(res => {
        console.log(res)
        for (let i = 0; i < res.data.rows.length; i++) {
          res.data.rows[i].mti_lijian = this.cutZero(parseFloat(res.data.rows[i].mti_money_1 - res.data.rows[i].mti_money_2).toFixed(2))
          res.data.rows[i].mti_money_1 = parseFloat(res.data.rows[i].mti_money_1).toFixed(2)
          res.data.rows[i].mti_money_2 = parseFloat(res.data.rows[i].mti_money_2).toFixed(2)
        }

        this.ticket_list3 = res.data.rows
        this.lquanListLength = this.ticket_list3.length
        if (this.lquan_timer) {
          clearInterval(this.lquan_timer)
        }
        if (this.lquanListLength > 4) {
          this.lquanInterval = 10000
          this.lquan_timer = setInterval(() => {
            this.handleLquanlChange()
          }, this.lquanInterval)
        } else {
          this.lquanInterval = 0
        }
        this.updateLquanItems()
      }).catch(err => {
        console.log('失败 ' + err)
      })
    },

    get_ticket_list_more () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getTicketsByCityAndType,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
            mti_city_id: this.pri_detail.activityObj.city_id,
            device_id: this.pri_detail.activityObj.di_uuid,
            mti_type: this.mti_type,
            card_type: this.card_type,
            perPageSize: this.ticket_list4.perPageSize,
            currentPage: this.ticket_list4.currentPage
          }
        )
      ).then(res => {
        console.log(res)
        for (let i = 0; i < res.data.rows.length; i++) {
          res.data.rows[i].mti_lijian = this.cutZero(parseFloat(res.data.rows[i].mti_money_1 - res.data.rows[i].mti_money_2).toFixed(2))
          res.data.rows[i].mti_money_1 = parseFloat(res.data.rows[i].mti_money_1).toFixed(2)
          res.data.rows[i].mti_money_2 = parseFloat(res.data.rows[i].mti_money_2).toFixed(2)
        }

        let currentPage = this.ticket_list4.currentPage
        let perPageSize = this.ticket_list4.perPageSize
        this.ticket_list4 = res.data
        this.ticket_list4.currentPage = currentPage
        this.ticket_list4.perPageSize = perPageSize

      }).catch(err => {
        console.log('失败 ' + err)
      })
    },

    show_ticket_list (item) {

      this.ticket_list.rows.ttd_name = item.ttd_name
      this.ticket_list.rows.bti_note = item.bti_note
      this.ticket_list.rows.bti_id = item.bti_id
      // this.ticket_list.rows.bti_daily_start_time = item.bti_daily_start_time
      // this.ticket_list.rows.bti_daily_end_time = item.bti_daily_end_time

      if (item.bti_daily_start_time === undefined || item.bti_daily_end_time === undefined) {
        this.$message('暂无活动')
        return false
      } else {
        this.ticket_list_show = true
        var start_time = item.bti_daily_start_time.split(':')
        var end_time = item.bti_daily_end_time.split(':')

        start_time = Number(start_time[0]) * 3600 + Number(start_time[1]) * 60 + Number(start_time[2])
        end_time = Number(end_time[0]) * 3600 + Number(end_time[1]) * 60 + Number(end_time[2])

        var date = new Date()
        var hour = date.getHours()
        var minute = date.getMinutes()
        var seconds = date.getSeconds()

        var cur_time = Number(hour) * 3600 + Number(minute) * 60 + Number(seconds)

        if (cur_time < start_time) {
          this.ticket_activity_time = '1'
          this.activity_time(cur_time, start_time, item)
        } else if (cur_time > end_time) {
          this.ticket_activity_time = '2'
        } else {
          this.ticket_activity_time = '3'
          this.activity_time(cur_time, end_time, item)
        }

        this.get_mer_ticket_list()
      }
    },

    close_ticket_list () {
      this.ticket_list_show = false
      clearInterval(this.activity_timer)
    },

    close_ticket_detail () {
      this.show_ticket_detail = false
    },

    get_mer_ticket_list () {

      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)',
      })
      let jsondata = {
        mti_bti_id: this.ticket_list.rows.bti_id,
        device_id: this.pri_detail.activityObj.di_uuid,
        perPageSize: this.mer_ticket_list.perPageSize,
        currentPage: this.mer_ticket_list.currentPage,
      }

      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getMerTicketList,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify(jsondata)
      )
      a1.then((res) => {
        loading.close()
        for (let i = 0; i < res.data.rows.length; i++) {
          res.data.rows[i].mti_money_1 = parseFloat(res.data.rows[i].mti_money_1).toFixed(2)
          res.data.rows[i].mti_money_2 = parseFloat(res.data.rows[i].mti_money_2).toFixed(2)
        }
        this.mer_ticket_list.rows = res.data.rows
        this.mer_ticket_list.total = res.data.total
      })
    },

    prePage () {
      if (this.mer_ticket_list.currentPage === 1) {
        this.$message('当前已经是第一页了')
        return false
      }

      this.mer_ticket_list.currentPage--
      this.get_mer_ticket_list()
    },

    nextPage () {

      var tail = Math.ceil(parseFloat(this.mer_ticket_list.total) / parseFloat(this.mer_ticket_list.perPageSize))
      if (this.mer_ticket_list.currentPage === tail) {
        this.$message('当前已经是最后一页了')
        return false
      }

      this.mer_ticket_list.currentPage++
      this.get_mer_ticket_list()
    },

    activity_time (cur_time, startOrEnd_time, item) {
      this.residue_time = startOrEnd_time - cur_time
      var residue_seconds = this.residue_time
      var residue_minutes = 0
      var residue_hours = 0
      if (residue_seconds > 59) {
        residue_minutes = parseInt(residue_seconds / 60)
        residue_seconds = parseInt(residue_seconds % 60)
        if (residue_minutes > 59) {
          residue_hours = parseInt(residue_minutes / 60)
          residue_minutes = parseInt(residue_minutes % 60)
        }
      }

      this.residue_hour = residue_hours
      this.residue_minutes = residue_minutes
      this.residue_seconds = residue_seconds

      this.activity_timer = setInterval(() => {
        this.residue_seconds--
        if (this.residue_seconds === -1) {
          this.residue_minutes--
          this.residue_seconds = 59
        }
        if (this.residue_minutes === -1) {
          this.residue_hour--
          this.residue_minutes = 59
        }
        if (this.residue_hour === -1) {
          this.show_ticket_list(item)
        }
      }, 1000)

    },

    ticket_detail (item) {
      this.show_ticket_detail = true
      this.ticket_detail_rows = item
      this.get_use_shop_list(item.mti_ticket_id, item.mti_mer_id)

    },

    get_use_shop_list (ticket_id, mer_id) {

      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.queryMerStoreTagInfo,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          mti_ticket_id: ticket_id,
          mti_mer_id: mer_id
        })
      ).then(res => {
        for (let i = 0; i < res.data.rows.length; i++) {
          res.data.rows[i].mti_money_1 = parseInt(res.data.rows[i].mti_money_1)
          res.data.rows[i].mti_money_2 = parseInt(res.data.rows[i].mti_money_2)
        }
        this.use_shop_list = res.data.rows
      }).catch(err => {
        console.log('失败')
      })
    },
    qrCodeWeChat() {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.qrCodeWeChat,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          obj_station_id: this.pri_detail.activityObj.station_id,
          bdbi_qr_type: 2
        })
      ).then(res => {
        this.bdbi_path_qr = res.data.bdbi_path
      }).catch(err => {
        console.log('失败')
      })
    },
    updateItems () {
      setInterval(() => {
        if(this.$refs['bdbiShow']) {
          this.$refs['bdbiShow'].updateItems()
          this.initialIndex = this.curIndex
        }
      }, 5000)
    },
    simulateTouchClick(element, x, y) {
      const rect = element.getBoundingClientRect();
      const targetX = x || rect.left + rect.width / 2;
      const targetY = y || rect.top + rect.height / 2;

      const touch = new Touch({
        identifier: Date.now(),
        target: element,
        clientX: targetX,
        clientY: targetY,
        radiusX: 2.5,
        radiusY: 2.5,
        rotationAngle: 0,
        force: 1
      });

      const touchStart = new TouchEvent('touchstart', {
        bubbles: true,
        cancelable: true,
        touches: [touch],
        targetTouches: [touch],
        changedTouches: [touch]
      });

      const touchEnd = new TouchEvent('touchend', {
        bubbles: true,
        cancelable: true,
        touches: [],
        targetTouches: [],
        changedTouches: [touch]
      });

      element.dispatchEvent(touchStart);
      element.dispatchEvent(touchEnd);

      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        clientX: targetX,
        clientY: targetY
      });
      element.dispatchEvent(clickEvent);
    },

  addTouchFeedback(x, y) {
    const feedback = document.createElement('div');
    feedback.style.position = 'fixed';
    feedback.style.left = `${x}px`;
    feedback.style.top = `${y}px`;
    feedback.style.width = '40px';
    feedback.style.height = '40px';
    feedback.style.borderRadius = '50%';
    feedback.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
    feedback.style.transform = 'translate(-50%, -50%)';
    feedback.style.pointerEvents = 'none';
    feedback.style.animation = 'touch-feedback 0.3s ease-out';

    document.body.appendChild(feedback);

    feedback.addEventListener('animationend', () => {
      feedback.remove();
    });
  },

  simulateFullClick(element) {
    const rect = element.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    this.simulateTouchClick(element, x, y);
    this.addTouchFeedback(x, y);
  },
    // 定义事件触发函数
    simulateClick() {
      // 创建事件对象
      const element = this.$refs['myButton']
      const mouseDown = new MouseEvent('mousedown', {
        bubbles: true,    // 允许事件冒泡
        cancelable: true, // 允许事件被取消
        view: window      // 关联的窗口对象
      });

      const mouseUp = new MouseEvent('mouseup', { bubbles: true, cancelable: true });
      const click = new MouseEvent('click', { bubbles: true, cancelable: true });

      // 分派事件（按正确顺序）
      element.dispatchEvent(mouseDown);
      element.dispatchEvent(mouseUp);
      element.dispatchEvent(click);
    },
    handleClick() {
      console.log('按钮被点击了！');
    },
    handleFocus() {
      console.log('按钮获取了焦点！');
    },
    htouch () {
      // 获取目标元素
      const targetElement = this.$refs['myButton']

      // 创建触摸点
      const touch = new Touch({
        identifier: Date.now(), // 唯一标识
        target: targetElement,  // 目标元素
        clientX: 100,           // 触摸点 X 坐标
        clientY: 100,           // 触摸点 Y 坐标
        radiusX: 2.5,           // 触摸点 X 方向半径
        radiusY: 2.5,           // 触摸点 Y 方向半径
        rotationAngle: 0,       // 旋转角度
        force: 1                // 触摸压力
      });

      // 创建 touchstart 事件
      const touchStartEvent = new TouchEvent('touchstart', {
        touches: [touch],       // 当前触摸点
        targetTouches: [],      // 目标元素上的触摸点
        changedTouches: [touch],// 变化的触摸点
        bubbles: true,          // 是否冒泡
        cancelable: true        // 是否可取消
      });

// 创建 touchend 事件
      const touchEndEvent = new TouchEvent('touchend', {
        touches: [],            // 当前触摸点（已抬起）
        targetTouches: [],      // 目标元素上的触摸点
        changedTouches: [touch],// 变化的触摸点
        bubbles: true,          // 是否冒泡
        cancelable: true        // 是否可取消
      });

// 触发事件
      targetElement.dispatchEvent(touchStartEvent);
      targetElement.dispatchEvent(touchEndEvent);

// 触发 click 事件
      targetElement.click();
    },
    handleCarouselClick () {
      if (this.reloadTime) {
        this.reloadTime = 0
        return
      }
      setTimeout(() => {
        this.isVisible = false // 隐藏组件
        this.$nextTick(() => {
          this.isVisible = true // 显示组件
          this.initialIndex = this.curIndex
        })
        // window.location.reload()
        // this.$router.go(0)
        // 模拟点击
        // const button = this.$refs.myButton
        // // 触发完整的事件流
        // const mouseDownEvent = new MouseEvent('mousedown', { bubbles: true });
        // button.dispatchEvent(mouseDownEvent);
        //
        // const mouseUpEvent = new MouseEvent('mouseup', { bubbles: true });
        // button.dispatchEvent(mouseUpEvent);
        //
        // const clickEvent = new MouseEvent('click', { bubbles: true });
        // button.dispatchEvent(clickEvent);
        //
        // // 确保获取焦点
        // button.focus();
        // const focusEvent = new Event('focus', { bubbles: true });
        // button.dispatchEvent(focusEvent);
        //
        // const carousel = this.$refs.bdbiShow
        // carousel.autoplay.start()
        // debugger
        // // 重置轮播动画
        // if (carousel && carousel.resetAnimation) {
        //   carousel.resetAnimation();
        // }
      }, 500)
    },
    SVGA () {
      let player = new SVGA.Player("#demoCanvas")
      let parser = new SVGA.Parser("#demoCanvas")
      parser.load(this.bgImg,function (videoItem) {
          player.loops = 1
          player.setVideoItem(videoItem)
          player.startAnimation()
          player.clear()
        }
      )
    },
    setFill() {               //适配不同屏
      debugger
      var $_canvas = document.getElementById("demoCanvas"),
        w = window.innerWidth,
        h = window.innerHeight,
        screen_proportion = h / w,
        svga_proportion = 16 / 9;
      if (screen_proportion > svga_proportion) {
        //长屏幕
        $_canvas.style.width = h / svga_proportion + "px";
        $_canvas.style.left = (w - h / svga_proportion) / 2 + "px";
      } else {
        $_canvas.style.height = w * svga_proportion + "px";
        $_canvas.style.top = (h - w * svga_proportion) / 2 + "px";
      }
    },
    updateVisibleItems () {
      this.visibleItems = this.imageList.slice(0, 6)
      // this.visibleItems = this.imageList.slice(this.startIndex, this.startIndex + 4)
    },
    updateGoodsItems ()  { //多元素轮播
      this.goodsItems = this.commodity_tableData.slice(0, 4)
    },
    updateQuanItems ()  { //多元素轮播
      this.quanItems = this.ticket_list2.slice(0, 6)
    },
    updateLquanItems () { //多元素轮播
      this.lquanItems = this.ticket_list3.slice(0, 4)
    },
    handleCarouselChange (index, oldIndex) { //多元素轮播
      let firstElement = this.imageList.shift()
      this.imageList.push(firstElement)
      this.updateVisibleItems()
    },
    goodsCarouselChange () {
      let firstElement = this.commodity_tableData.shift()
      this.commodity_tableData.push(firstElement)
      this.updateGoodsItems()
    },
    handleQuanlChange () {
      let firstElement = this.ticket_list2.shift()
      this.ticket_list2.push(firstElement)
      this.updateQuanItems()
    },
    handleLquanlChange () {
      let firstElement = this.ticket_list3.shift()
      this.ticket_list3.push(firstElement)
      this.updateLquanItems()
    },
    changeplay (index, oldIndex) {
      this.curIndex = index
      if (oldIndex < 0 || index === oldIndex) {
        return
      }
      this.nowIndex = index
      let item = this.img_data[oldIndex]
      if (item && item.bdbi_path.indexOf('.mp4') !== -1) {
        let myVideo = this.$refs['player' + oldIndex]
        if (myVideo && myVideo[0]) {
          myVideo[0].pause()
        }
      }
      let newItem = this.img_data[index]
      if (newItem && newItem.bdbi_path.indexOf('.mp4') !== -1) {
        let newVideo = this.$refs['player' + index]
        if (newVideo && newVideo[0]) {
          // if (newVideo[0].paused) {
          //
          // }
          newVideo[0].play()
        }
      }
      // this.$refs['video'].load()
      // this.$refs['video'].play()

      // if (play) {
      //   play.then(() => {
      //     // 视频频加载成功
      //     // 视频频的播放需要耗时
      //     setTimeout(() => {
      //       // 后续操作
      //       console.log("done.");
      //     }, video[0].duration * 1000); // video[0].duration 为视频频的时长，单位为秒
      //
      //
      //   }).catch((e) => {
      //     // 视频频加载失败
      //   })
      // }
    },
    pause (name) {
      this.$refs[name].pause()
    },
    radio_type () {
      if (this.radioType === '0') {
        this.hdEnable = false
        this.checkCode = ''
      } else {
        this.hdEnable = true
        this.phone = ''
      }
    },
    // json动图展示
    optAnimation () {
      lottie.destroy()
      this.$nextTick(() => {
        let elem = document.querySelector('.lottie')
        let params = {
          container: elem,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData,
        }
        lottie.loadAnimation(params)
      })
    },
    customMethod: function (args) {
      this.showtype = args
      switch (args) {
        case '1':

          break
        case '2':
          this.playAudio(9)
          // this.qr_code_show = false
          // this.payment_show_fail = false
          this.payment_show_success = true
          // this.$message('出货成功')
          break
        case '3':
          this.playAudio(10)
          // this.qr_code_show = false
          this.payment_show_success = false
          setTimeout(() => {
            this.payment_show_fail = true
          }, 500)
          // this.$message('出货失败')
          break
        case '4':
          this.business_select()
          break
      }
      console.info('args:' + args)
    },

    //图片加载失败循环加载
    srcerr: function (item, e) {
      let path = item.mbgi_goods_img_path
      console.info('error img path:' + path)
      // e.target.src = item.mbgi_goods_img_path
    },
    srcerr1: function (item, e) {
      let path = item.bdbi_path
      console.info('error img path:' + path)
      // e.target.src = item.bdbi_path
    },
    onChange: function (input) {
      console.log('Input changed', input)
      // this.money = input;
      if (this.radioType === '0') {
        this.phone = input
      } else {
        this.checkCode = input
      }
    },

    prev (txt, e) {
      e.preventDefault()
      console.info('' + txt)
      this.$refs.nop.prev()
    },
    next (txt, e) {
      e.preventDefault()
      console.info('' + txt)
      this.$refs.nop.next()
    },
    //数组重组
    formatArray: function (arr, num) {
      var newArray = new Array(Math.ceil(arr.length / num))
      for (var i = 0; i < newArray.length; i++) {
        newArray[i] = []
        // for (var j = 0; j < num; j++) {
        //   newArray[i][j] = {};
        // }
      }
      for (var i = 0; i < arr.length; i++) {
        newArray[parseInt(i / num)][i % num] = arr[i]
      }
      return newArray
    },
    /** 电话号校验 */
    isCellPhone (val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false
      } else {
        return true
      }
    },
    arrowClick (val) {
      if (val === 'right') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
    /**
     去掉小数多余的0
     */
    cutZero (old) {
      //拷贝一份 返回去掉零的新串
      let newstr = old
      //循环变量 小数部分长度
      var leng = old.length - old.indexOf('.') - 1
      //判断是否有效数
      if (old.indexOf('.') > -1) {
        //循环小数部分
        for (let i = leng; i > 0; i--) {
          //如果newstr末尾有0
          if (newstr.lastIndexOf('0') > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
            var k = newstr.lastIndexOf('0')
            //如果小数点后只有一个0 去掉小数点
            if (newstr.charAt(k - 1) == '.') {
              return newstr.substring(0, k - 1)
            } else {
              //否则 去掉一个0
              newstr = newstr.substring(0, k)
            }
          } else {
            //如果末尾没有0
            return newstr
          }
        }
      }
      return old
    },
    activity_list () {
      // 点开抽福袋
      this.audio3 = new Audio()
      this.audio3.src = 'https://pre.borunxinke.com:1443//fr/imgserver/d.mp3'
      this.audio3.play()
      this.activity_show = true
      this.activity_list_show = true
      this.activity_phone_show = false
      this.activity_prize_show = false
      this.pic_item1 = []
      this.showKeyBoard = false
      this.activity_list_select()
      this.startDivi()
    },
    activity_list_close () {
      this.showKeyBoard = false
      this.activity_show = false
      this.clearTime()
    },
    activity_list_select () {
      let that = this
      let _jsondata_ = {
        lai_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        lai_province_id: that.pri_detail.activityObj.province_id,
        lai_city_id: that.pri_detail.activityObj.city_id,
        lai_county_id: that.pri_detail.activityObj.county_id,
        lai_station_id: that.pri_detail.activityObj.station_id,
        lai_detail_status: '1',
        lai_waring: '1',
        perPageSize: 20,
        currentPage: 1,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Sweepstakes_Activities_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status == 'success') {
            loading.close()
            that.tableData = res.data.rows
            var date = new Date()
            var year = date.getFullYear()
            var month =
              date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1
            var day =
              date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours =
              date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes =
              date.getMinutes() < 10
                ? '0' + date.getMinutes()
                : date.getMinutes()
            var seconds =
              date.getSeconds() < 10
                ? '0' + date.getSeconds()
                : date.getSeconds()
            var data_id =
              year +
              '-' +
              month +
              '-' +
              day +
              ' ' +
              hours +
              ':' +
              minutes +
              ':' +
              seconds
            console.log('当前时间：' + data_id)
            that.data_id = data_id
            var _tmp1_ = []
            that.tableData.forEach(function (item, index) {
              that.data_time1 = that.customGlobal.getDateTimeToTimestamp(
                item.lai_start_time
              )
              that.data_time3 =
                that.customGlobal.getDateTimeToTimestamp(data_id)

              if (that.data_time1 > that.data_time3) {
                // that.tableData.splice(index,1)
                console.log('删除开始时间:' + that.data_time1)
                console.log('删除当前时间：' + that.data_time3)
                console.log('item:' + JSON.stringify(item))
              } else {
                console.log('保留开始时间:' + that.data_time1)
                console.log('保留当前时间：' + that.data_time3)
                _tmp1_.push(item)
              }
            })
            if (_tmp1_ !== []) {
              that.tableData = _tmp1_
            }
            console.log('table:' + JSON.stringify(that.tableData))
            that.activity_list_select1()
          } else {
            console.info('活动查询失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
          // this.companyDialogFormVisible =false;//保存失败关闭dialog
          this.$alert(JSON.stringify(error.message), '活动查询出错!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '活动查询出错', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
      })
    },
    activity_list_select1 () {
      let that = this
      let _jsondata_ = {
        lai_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        lai_province_id: that.pri_detail.activityObj.province_id,
        lai_city_id: that.pri_detail.activityObj.city_id,
        lai_county_id: that.pri_detail.activityObj.county_id,
        lai_station_id: that.pri_detail.activityObj.station_id,
        lai_detail_status: '1',
        lai_waring: '2',
        perPageSize: 20,
        currentPage: 1,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Sweepstakes_Activities_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status == 'success') {
            loading.close()
            that.tableData1 = []
            that.pic_item1 = []
            that.tableData1 = res.data.rows
            that.tableData1.forEach(function (item, index) {
              var tab = that.tableData.push(item)
              console.log('that.tableData：' + JSON.stringify(that.tableData))
              // console.log("item：" + JSON.stringify(item))
              console.log('tab：' + JSON.stringify(tab))
            })
            that.pic_item1 = this.formatArray(that.tableData, 5)
            var date = new Date()
            var year = date.getFullYear()
            var month =
              date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1
            var day =
              date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours =
              date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes =
              date.getMinutes() < 10
                ? '0' + date.getMinutes()
                : date.getMinutes()
            var seconds =
              date.getSeconds() < 10
                ? '0' + date.getSeconds()
                : date.getSeconds()
            var data_id =
              year +
              '-' +
              month +
              '-' +
              day +
              ' ' +
              hours +
              ':' +
              minutes +
              ':' +
              seconds
            console.log('当前时间：' + data_id)
            that.pic_item1.forEach(function (item, index) {
              item.forEach(function (item1, index1) {
                console.log(item1.lai_start_time)
                if (item1.lai_start_time > data_id) {
                  that.data_time1 = that.customGlobal.getDateTimeToTimestamp(
                    item1.lai_start_time
                  )
                  that.data_time3 =
                    that.customGlobal.getDateTimeToTimestamp(data_id)
                  that.data_time2 = that.customGlobal.getTimestampToDateTime(
                    that.customGlobal.getDateTimeToTimestamp(
                      item1.lai_start_time
                    ) -
                    item1.lai_waring_time * 84600 * 1000
                  )
                  // console.log("that.data_time1:"+that.data_time1)
                  // console.log("that.data_time2:"+that.data_time2)
                  // console.log("that.data_time3:"+that.data_time3)
                  var time_id = that.data_time1 - that.data_time3
                  console.log('time_id:' + time_id)
                  var days = Math.floor(time_id / (24 * 3600 * 1000))
                  //计算出小时数
                  var leave1 = time_id % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
                  var hours = Math.floor(leave1 / (3600 * 1000))
                  //计算相差分钟数
                  var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
                  var minutes = Math.floor(leave2 / (60 * 1000))
                  var dayStr = days == 0 ? '' : days + '天'
                  var hoursStr = hours == 0 ? '' : hours + '时'
                  var time = dayStr + hoursStr + minutes + '分'
                  console.log('time:' + time)

                  item1.time = time
                }
              })
            })
          } else {
            console.info('活动查询失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
          // this.companyDialogFormVisible =false;//保存失败关闭dialog
          this.$alert(JSON.stringify(error.message), '活动查询出错!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '活动查询出错', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
      })
    },
    //清除定时器
    clearTime () {
      clearInterval(this.timer)
    },
    //60秒钟关闭本弹窗
    startDivi () {
      const TIME_COUNT = 60
      this.count = TIME_COUNT
      this.activity_show = true
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--
        } else {
          this.activity_show = false
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    //90秒钟关闭本弹窗
    startDivi1 () {
      const TIME_COUNT = 120
      this.count = TIME_COUNT
      this.activity_show = true
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--
        } else {
          this.activity_show = false
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    //打开商品详情支付页面
    qr_code_but (item) {
      if (item.count_num <= 0) {
        return
      }
      this.playAudio(7)
      this.objMsg = item
      this.qr_code_show = true
      this.wxts_view = false
      this.img_commodity.msg = ''
      this.img_commodity.billNo = ''
      this.shop_btn_index = 0
      let goods = this.objMsg.mdgi_uuid_numbers.split(',')
      let curObj = goods[0].split('-')
      this.objMsg.mbs_goods_uuid = curObj[1]
      this.objMsg.mdgi_number = curObj[0]
      console.log('objMsg:', this.objMsg)
      this.saveTotalViewCountDay(10)
      this.commodity_qc_code(3)
    },
    postQueryGoodsAttachMerInfo () {
      let _jsondata_ = {
        mbgi_source: this.objMsg.mbgi_source,
        mbgi_sale_mode: this.objMsg.mbgi_sale_mode,
        mbgi_station_id: this.objMsg.mbgi_station_id,
        mbgi_mer_uuid: this.objMsg.mbgi_mer_uuid
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)',
      })
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postQueryGoodsAttachMerInfo,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status == 'success') {
            loading.close()
            this.$set(this.objMsg, 'objMsg_address', res.data.rows[0].address)
            this.$set(this.objMsg, 'objMsg_company', res.data.rows[0].company)
            console.log(
              'res==',
              this.objMsg,
              '---------------------------------------------------------'
            )
          } else {
            console.info('商品查询失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
      })
    },
    // 所有窗口都在这里关闭
    window_close_all () {
      this.qr_code_show = false
      this.payment_show_fail = false
      this.payment_show_success = false
      this.count = ''
      // if (this.window_timer) {
      //   clearInterval(this.window_timer)
      //   this.window_timer = ''
      // }
      this.get_ticket_list2(1)
      this.get_ticket_list3(1)
      this.commodity_list_select()
    },

    // 首页获取福利团商品列表查询
    commodity_list_select () {
      let that = this
      let _jsondata_ = {
        mbgi_show: '1',
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        mgs_device_uuid: that.pri_detail.activityObj.di_uuid,
        perPageSize: 1000,
        currentPage: 1
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      // 首页获取福利团商品数据
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.Equipment_home_page_commodity_display_select,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status == 'success') {
            loading.close()
            that.commodity_tableData = res.data.rows
            that.goodsListLength = res.data.rows.length
            if (this.goods_timer) {
              clearInterval(this.goods_timer)
            }
            if (this.goodsListLength > 4) {
              this.goodsInterval = 10000
              this.goods_timer = setInterval(() => {
                this.goodsCarouselChange()
              }, this.goodsInterval)
            } else {
              this.goodsInterval = 0
            }
            that.updateGoodsItems()
          } else {
            console.info('商品查询失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
      })
    },
    wxtsClick() {
      this.wxts_view = false
    },
    //生成二维码 优惠价传2，特惠价传3
    commodity_qc_code (mbs_pay_mode) {
      let baseURI

      this.shop_btn_index = mbs_pay_mode
      if (mbs_pay_mode === 3) {
        this.wxts_view = true
      } else {
        this.wxts_view = false
      }
      if (this.objMsg.mbgi_source == '1') {
        baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForInnerBank
      } else {
        //货道内扫码(非银行礼品)
        baseURI = this.customGlobal.serverUrl.postManagerGenUnionQrCodeForInnerMer
      }
      let that = this
      this.img_commodity.msg = ''
      this.img_commodity.billNo = ''
      let _jsondata_ = {
        bank_company_alias_id: that.transcoding_id.currentCompanyId,
        totalAmount: that.objMsg['mbgi_money_' + mbs_pay_mode],
        sale_info: JSON.stringify({
          mbs_sale_mode: this.objMsg.mbgi_sale_mode,
          mbs_use_uuid: '',
          mbs_mer_uuid: that.objMsg.mbgi_mer_uuid,
          // mbs_guest_phone: this.phone,
          mbs_goods_uuid: this.objMsg.mbs_goods_uuid,
          mbs_goods_type_uuid: that.objMsg.mbgi_uuid,
          mbs_pay_mode: mbs_pay_mode,
          mbs_device_id: that.pri_detail.activityObj.di_uuid,
          mdgi_number: this.objMsg.mdgi_number,
        }),
        mgs_device_id: that.pri_detail.activityObj.di_uuid,
        mgs_mer_uuid: that.objMsg.mbgi_mer_uuid,
        bank_center_id: that.pri_detail.activityObj.bank_center_id,
        province_id: that.pri_detail.activityObj.province_id,
        city_id: that.pri_detail.activityObj.city_id,
        county_id: that.pri_detail.activityObj.county_id,
        station_id: that.pri_detail.activityObj.station_id,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      var a1 = this.customGlobal.postHttpClient(
        baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status == 'success') {
            that.timer_second = 120
            loading.close()
            that.img_commodity = res.data
            console.log('二维码：' + JSON.stringify(that.img_commodity.msg))
          } else {
            console.info('生成二维码失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
          // this.companyDialogFormVisible =false;//保存失败关闭dialog
          this.$alert(JSON.stringify(error.message), '生成二维码出错!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
          that.img_commodity = null
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '生成二维码出错', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
        that.img_commodity = null
      })
    },
    //转13位id
    bank_commodity () {
      let that = this
      let _jsondata_ = {
        companyId: that.pri_detail.activityObj.station_id,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      var s1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.bank_transcoding,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      s1.then(
        (res) => {
          if (res.data.status == 'success') {
            loading.close()
            that.transcoding_id = res.data
            that.bankName = res.data.bankName
            that.bankIcon = res.data.bci_icon_path
          } else {
            console.info('转码失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
          // this.companyDialogFormVisible =false;//保存失败关闭dialog
          this.$alert(JSON.stringify(error.message), '转码出错!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '转码出错', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
      })
    },

    // 查询是否支付
    commodity_payment () {
      let that = this
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var billDate = year + '-' + month + '-' + day
      let _jsondata_ = {
        bank_company_alias_id: that.transcoding_id.currentCompanyId,
        billNo: that.img_commodity.billNo,
        billDate: billDate
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '',
      //   target: '.main',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0)',
      // })
      var s1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManagerQueryUnionPayOrderForOuter,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      s1.then(
        (res) => {
          if (res.data.status == 'success') {
            // loading.close()
            // console.log('支付中' + JSON.stringify(res.data))
            if (res.data.billStatus === 'PAID') {
              this.qr_code_show = false
              this.payment_show_success = true
              this.showtype = 5
              this.playAudio(8)
              if (this.objMsg.mbgi_sale_mode == '1') {
                let mbgi_money = JSON.parse(res.data.msg).billPayment.totalAmount
                es6.callAndroidDeviceReqShipMethod(that.objMsg.mdgi_number, 'PAYMETHED_WECHAT', mbgi_money, res.data.billNo)
              }
              // this.commodity_list_select()
            } else if (res.data.billStatus === 'TRADE_REFUND') {
              this.qr_code_show = false
              this.payment_show_fail = true
              this.showtype = 0
              // this.$message({
              //   offset: 0,
              //   type: 'warning',
              //   showClose: true,
              //   duration: 5000,
              //   dangerouslyUseHTMLString: true,
              //   message:
              //     '<span style="color:black;font-size: 50px">请使用指定银行卡进行支付！</span>'
              // })
            }
          } else {
            this.qr_code_show = false
            // loading.close()
          }
        },
        (error) => {
          this.qr_code_show = false
          // loading.close()
          this.$alert(JSON.stringify(error.message), '转码出错!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
        }
      ).catch((res) => {
        this.qr_code_show = false
        console.log('异步调用失败返回:' + JSON.stringify(res))
        // loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '转码出错', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
      })
    },


    next1 (txt, e) {
      e.preventDefault()
      console.info('' + txt)
      this.$refs.cardShow.next()
    },
    prev1 (txt, e) {
      e.preventDefault()
      console.info('' + txt)
      this.$refs.cardShow.next()
    },

    //查询图片
    img_select () {
      let that = this
      that.img_data = []
      let _jsondata_ = {
        perPageSize: 100,
        currentPage: 1,
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        bdbi_type: '1',
        company_id: that.customGlobal.userInfoExt.company_id,
        bdbi_status: '1',
        bdbi_device_id: that.pri_detail.activityObj.di_uuid,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Advertisement_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status === 'success') {
            loading.close()
            that.img_data = res.data.rows

            // that.img_data.push({bdbi_path: "https://pre.borunxinke.com:1443//fr/imgserver/13078781111//20241118091728555.png"})
            // for (let item of res.data.rows) {
            //   that.img_data.push(item)
            // }
            // that.img_data.push({bdbi_path: 'https://pre.borunxinke.com:1443/fr/imgserver/test2.mp4'})
            // that.img_data.push({bdbi_path: 'https://pre.borunxinke.com:1443/fr/imgserver/test.mp4'})
            if(that.img_data.length === 0) {
              return
            }
            setTimeout(() => {
              if (that.img_data[0].bdbi_path.indexOf('.mp4') !== -1) {
                let newVideo = that.$refs['player0']
                if (newVideo && newVideo[0]) {
                  newVideo[0].play()
                }
              }
            }, 500)
            // for (let item of that.img_data) {
            //   if (item.bdbi_path.indexOf('.mp4') !== -1) {
            //     that.videoUrl = item.bdbi_path
            //     break
            //   }
            // }
          } else {
            console.info('图片查询失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
          // this.companyDialogFormVisible =false;//保存失败关闭dialog
          this.$alert(JSON.stringify(error.message), '图片查询失败!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '图片查询失败', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
      })
    },
    //查询首页二维码
    img_select1 () {
      let that = this
      let _jsondata_ = {
        perPageSize: 100,
        currentPage: 1,
        obj_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        obj_province_id: that.pri_detail.activityObj.province_id,
        obj_city_id: that.pri_detail.activityObj.city_id,
        obj_county_id: that.pri_detail.activityObj.county_id,
        obj_station_id: that.pri_detail.activityObj.station_id,
        company_id: that.customGlobal.userInfoExt.company_id,
        bdbi_type: '3',
        bdbi_status: '1',
        bdbi_device_id: '',
        bdbi_qr_type: '2',
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManager_Advertisement_select,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status === 'success') {
            loading.close()
            let code_img_data = res.data.rows
            if (code_img_data.length > 0) {
              that.bdbi_path = code_img_data[0].bdbi_path
            }
          } else {
            console.info('图片查询失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
          // this.companyDialogFormVisible =false;//保存失败关闭dialog
          this.$alert(JSON.stringify(error.message), '图片查询失败!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '图片查询失败', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
      })
    },
    // 银行活动月月有利
    business_select () {
      let that = this
      let _jsondata_ = {
        perPageSize: 1000,
        currentPage: 1,
        bai_bank_center_id: that.pri_detail.activityObj.bank_center_id,
        bai_province_id: that.pri_detail.activityObj.province_id,
        bai_city_id: that.pri_detail.activityObj.city_id,
        bai_county_id: that.pri_detail.activityObj.county_id,
        bai_station_id: that.pri_detail.activityObj.station_id,
      }
      const loading = this.$loading({
        lock: true,
        text: '',
        target: '.main',
        spinner: 'el-icon-loading',

        background: 'rgba(0, 0, 0, 0)',
      })
      var a1 = this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.postManagerBankGuestGetActivityList,
        //this.customGlobal.serverUrl.baseURI,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({jsondata: JSON.stringify(_jsondata_)})
      )
      a1.then(
        (res) => {
          if (res.data.status === 'success') {
            loading.close()
            that.business_data = []
            that.business_data1 = []
            that.business_data1 = res.data.rows
            that.business_data = this.formatArray(that.business_data1, 3)
          } else {
            console.info('活动查询失败')
            loading.close()
            if (res.data.msg === '请登录认证') {
              this.$router.push({path: '/login'})
            }
          }
        },
        (error) => {
          loading.close()
          // this.companyDialogFormVisible =false;//保存失败关闭dialog
          this.$alert(JSON.stringify(error.message), '活动查询失败!', {
            confirmButtonText: '确定',
            callback: (action) => {
            },
          })
        }
      ).catch((res) => {
        console.log('异步调用失败返回:' + JSON.stringify(res))
        loading.close()
        // this.companyDialogFormVisible =false;//保存失败关闭dialog
        this.$alert(JSON.stringify(res.message), '活动查询失败', {
          confirmButtonText: '确定',
          callback: (action) => {
          },
        })
      })
    },
    prev2 (txt, e) {
      e.preventDefault()
      console.info('' + txt)
      this.$refs.nop1.prev()
    },
    next2 (txt, e) {
      e.preventDefault()
      console.info('' + txt)
      this.$refs.nop1.next()
    },
    arrowClick2 (val) {
      if (val === 'right') {
        this.$refs.nop1.next()
      } else {
        this.$refs.nop1.prev()
      }
    },
    //数字人民币
    number_renminbi () {
      this.$alert('暂未开通', '操作提示', {
        dangerouslyUseHTMLString: true,
      })
    },
    click_index1 (id) {
      this.tabindex1 = id
    },
    click_index2 (id) {
      this.tabindex2 = id
      if (id === 5) {
        this.get_ticket_list2(1)
      } else if (id === 6) {
        this.get_ticket_list2(2)
      } else if (id === 7) {
        this.get_ticket_list2(3)
      }
    },
    click_index3 (id) {
      this.tabindex3 = id
      if (id === 8) {
        this.get_ticket_list3(1)
      } else if (id === 9) {
        this.get_ticket_list3(2)
      } else if (id === 10) {
        this.get_ticket_list3(3)
      }
    },
    click_more_details (id) {
      this.tabindex4 = id
      this.card_type = id
      this.get_ticket_list_more()
    },
    supermarket_details (id) {
      this.tbs_type = id
      this.supermarketIndex = 0
      this.getSupermarketsByBankId()
    },
    supermarket_content (item, index) {
      this.supermarket = item
      this.supermarketIndex = index
      this.saveJrcsViewCountDay()
    },
    saveJrcsViewCountDay () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.saveJrcsViewCountDay,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
            jrvcd_type: this.tbs_type,
            device_id: this.pri_detail.activityObj.di_uuid,
            jrvcd_tbs_id: this.supermarket.tbs_id ? this.supermarket.tbs_id : '',
            bank_center_id: this.pri_detail.activityObj.bank_center_id,
            province_id: this.pri_detail.activityObj.province_id,
            city_id: this.pri_detail.activityObj.city_id,
            county_id: this.pri_detail.activityObj.county_id,
            station_id: this.pri_detail.activityObj.station_id
          }
        )
      ).then(res => {
        console.log(res)
      }).catch(err => {
        console.log('失败 ' + err)
      })
    },
    saveBankViewCountDay (type) {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.saveBankViewCountDay,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
            bvcd_type: type,
            device_id: this.pri_detail.activityObj.di_uuid,
            bank_center_id: this.pri_detail.activityObj.bank_center_id,
            province_id: this.pri_detail.activityObj.province_id,
            city_id: this.pri_detail.activityObj.city_id,
            county_id: this.pri_detail.activityObj.county_id,
            station_id: this.pri_detail.activityObj.station_id
          }
        )
      ).then(res => {
        console.log(res)
      }).catch(err => {
        console.log('失败 ' + err)
      })
    },
    // tvcd_type大分类 1联系银行、2活动专区、3金融超市、4新客专享、5福利锦囊、63立减券、64满减券、7合作商家、8布放热线、9运营资质、10设备端即时惠、11客服中心
    saveTotalViewCountDay (type) {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.saveTotalViewCountDay,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
            tvcd_type: type,
            device_id: this.pri_detail.activityObj.di_uuid,
            bank_center_id: this.pri_detail.activityObj.bank_center_id,
            province_id: this.pri_detail.activityObj.province_id,
            city_id: this.pri_detail.activityObj.city_id,
            county_id: this.pri_detail.activityObj.county_id,
            station_id: this.pri_detail.activityObj.station_id
          }
        )
      ).then(res => {
        console.log(res)
      }).catch(err => {
        console.log('失败 ' + err)
      })
    },
    kefu_click () {
      let button1 = document.getElementById('button1')
      let button2 = document.getElementById('button2')
      let button3 = document.getElementById('button3')
      let button4 = document.getElementById('button4')
      button1.style.backgroundColor = '#096FB8'
      button2.style.backgroundColor = ''
      button3.style.backgroundColor = ''
      button4.style.backgroundColor = ''

      this.yinhang_dialog_flag = 1
      this.get_client_list()
    },
    replaceMultipleNewlinesWithSingle(str) {
      return str.replace(/\n{2,}/g, '\n')
    },
    zhanghao_click () {
      let button1 = document.getElementById('button1')
      let button2 = document.getElementById('button2')
      let button3 = document.getElementById('button3')
      let button4 = document.getElementById('button4')
      button1.style.backgroundColor = ''
      button2.style.backgroundColor = '#096FB8'
      button3.style.backgroundColor = ''
      button4.style.backgroundColor = ''

      this.yinhang_dialog_flag = 2
      this.get_official_list1()
      /*      this.get_official_list2()*/
    },
    bank_click () {
      let button1 = document.getElementById('button1')
      let button2 = document.getElementById('button2')
      let button3 = document.getElementById('button3')
      let button4 = document.getElementById('button4')
      button1.style.backgroundColor = ''
      button2.style.backgroundColor = ''
      button3.style.backgroundColor = '#096FB8'
      button4.style.backgroundColor = ''

      this.yinhang_dialog_flag = 3
      this.get_contact()
    },
    wangdian_click () {
      let button1 = document.getElementById('button1')
      let button2 = document.getElementById('button2')
      let button3 = document.getElementById('button3')
      let button4 = document.getElementById('button4')
      button1.style.backgroundColor = ''
      button2.style.backgroundColor = ''
      button3.style.backgroundColor = ''
      button4.style.backgroundColor = '#096FB8'

      this.yinhang_dialog_flag = 4
      this.stationAreasOption = ''
      this.saveBankViewCountDay(4)
      this.get_station_list()
      this.get_station_areas_list()
    },

    ticket_more_click (type) {
      this.mti_type = type
      this.lijian_more_show = true
      this.click_more_details(1)
    },

    lijian_click (item, type) {
      if (type === 4 || type === '4') {
        this.playAudio(11)
      } else {
        this.playAudio(12)
      }
      this.mti_type = type
      this.lijian_dialog_show = true
      this.bjSigns = item.bjSigns
      this.otherSigns = item.otherSigns
      this.saveTotalViewCountDay('6' + this.mti_type)
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getMerTicketInfoByActId,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
            mta_id: item.mta_id,
            device_id: this.pri_detail.activityObj.di_uuid
          }
        )
      ).then(res => {
        console.log(res)
        this.manjian_data = res.data.detail
        // this.manjian_data.mti_shop_content = this.guolvStr(this.manjian_data.mti_shop_content)
        this.discount = this.cutZero((this.manjian_data.mti_money_2 * 10 / this.manjian_data.mti_money_1).toFixed(2))
      }).catch(err => {
        console.log('失败 ' + err)
      })
    },
    // type =1 关闭工具券详情页 2关闭工具券查看更多 其他 关闭联系银行详情页面
    close_click (type) {
      if (type == 1) {
        this.lijian_dialog_show = false
        this.manjian_dialog_show = false
      } else if (type == 2) {
        this.lijian_more_show = false
      } else {
        this.lxyinhang_dialog_show = false
      }

    },
    handlePaste(event) {
      // event.preventDefault(); // 阻止粘贴操作
      // 或者可以执行其他的处理逻辑
    },
    handleKeyDown(event) {
      event.preventDefault()
    },
    yinhang_click () {
      this.playAudio(3)
      this.lxyinhang_dialog_show = true
      this.yinhang_dialog_flag = 1
      this.get_client_list()
    },
    jqqd () {
      this.$message('敬请期待')
    },
    jrcsImg (id, type) {
      this.reloadTime = id
      if (!id) {
        return
      }
      this.tbs_id = id
      this.tbs_type = type
      this.jrcs()
    },
    jrcs (id, type) {
      this.playAudio(4)
      this.jrcsDialog = true
      this.supermarket_details(this.tbs_type)
    },
    jrcs_close () {
      this.jrcsDialog = false
    },
    hdzq () {
      this.playAudio(2)
      this.hdzqDialog = true
      this.saveTotalViewCountDay(2)
      this.hdzqData.currentPage = 1
      this.hdzqlist()
    },
    hdzq_close () {
      this.hdzqDialog = false
    },
    imageClick (type) {
      if (type === 'xkzxOpen') {
        this.xkzxOpen()
      } else if (type === 'qhhdOpen') {
        this.qhhdOpen()
      } else if (type === 'jrcs') {
        this.jrcs()
      } else if (type === 'yinhang_click') {
        this.yinhang_click()
      } else if (type === 'hzsjOpen') {
        this.hzsjOpen()
      } else if (type === 'bfrxOpen') {
        this.bfrxOpen()
      } else if (type === 'hdzq') {
        this.hdzq()
      }
    },
    xkzxOpen () {
      this.playAudio(0)
      this.xkzxDialog = true
      this.saveTotalViewCountDay(4)
      this.xkzxData.currentPage = 1
      this.xkzxlist()
    },
    qhhdOpen () {
      this.playAudio(1)
      this.qhhdDialog = true
      this.saveTotalViewCountDay(5)
      this.qhhdData.currentPage = 1
      this.getAllBankActAll()
    },
    xkzx_close () {
      this.xkzxDialog = false
    },
    qhhd_close () {
      this.qhhdDialog = false
    },
    fljnOpen () { // 影音优惠站
      this.fljnDialog = true
      this.saveTotalViewCountDay(5)
      this.fljnDetail()
    },
    fljn_close () {
      this.fljnDialog = false
    },
    hzsjOpen () { // 成为合作商家
      this.playAudio(5)
      this.hzsjDialog = true
      this.saveTotalViewCountDay(7)
      this.hzsjDetail()
    },
    hzsj_close () {
      this.hzsjDialog = false
    },
    bfrxOpen () { // 客服中心
      this.playAudio(6)
      // this.bfrxDialog = true
      this.saveTotalViewCountDay(11)
      this.bfrxDetail()
    },
    bfrx_close () {
      this.bfrxDialog = false
    },
    yyzzOpen () {
      this.yyzzDialog = true
      this.saveTotalViewCountDay(9)
      this.yyzzDetail()
    },
    yyzz_close () {
      this.yyzzDialog = false
    },
    zxbz() { // 客服中心
      this.zxbzDialog = true
      this.saveTotalViewCountDay(11)
    },
    zxbz_close() {
      this.zxbzDialog = false
    },
    area_change (value) {
      this.stationAreasOption = value
      this.stationTableData.currentPage = 1
      this.get_station_list()
    },

    first_page () {
      this.stationTableData.currentPage = 1
      this.get_station_list()
    },

    pre_page () {
      if (this.stationTableData.currentPage === 1) {
        this.$message({
          message: '当前已经是第一页了',
          duration: '1500'
        })
        return false
      }

      this.stationTableData.currentPage--
      this.get_station_list()
    },

    next_page () {

      var tail = Math.ceil(parseFloat(this.stationTableData.total) / parseFloat(this.stationTableData.perPageSize))
      if (this.stationTableData.currentPage === tail) {
        this.$message({
          message: '当前已经是最后一页了',
          duration: '1500'
        })
        return false
      }

      this.stationTableData.currentPage++
      this.get_station_list()
    },

    pre_page1 () {
      if (this.ticket_list4.currentPage === 1) {
        this.$message({
          message: '当前已经是第一页了',
          duration: '1500'
        })
        return false
      }

      this.ticket_list4.currentPage--
      this.get_ticket_list_more()
    },

    next_page1 () {

      var tail = Math.ceil(parseFloat(this.ticket_list4.total) / parseFloat(this.ticket_list4.perPageSize))
      if (this.ticket_list4.currentPage === tail) {
        this.$message({
          message: '当前已经是最后一页了',
          duration: '1500'
        })
        return false
      }

      this.manjian_data.currentPage++
      this.get_ticket_list_more()
    },

    getSupermarketsByBankId () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getSupermarketsByBankId,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id,
          tbs_type: this.tbs_type,
          tbs_id: this.tbs_id,
          perPageSize: 100,
          currentPage: 1
        })
      ).then(res => {
        this.supermarketData = res.data.rows
        if (this.supermarketData.length > 0) {
          if (res.data.index && res.data.index > 0) {
            this.supermarketIndex = res.data.index
            this.supermarket = this.supermarketData[res.data.index]
          } else {
            this.supermarket = this.supermarketData[0]
          }
        } else {
          this.supermarket = {}
        }
        this.saveJrcsViewCountDay()
      }).catch(err => {
        console.log('失败:' + err)
      })
    },
    hdzqlist () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getActListInfoByDevice,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bai_station_id: this.pri_detail.activityObj.station_id,
          device_id: this.pri_detail.activityObj.di_uuid,
          perPageSize: this.hdzqData.perPageSize,
          currentPage: this.hdzqData.currentPage
        })
      ).then(res => {
        this.hdzqData.rows = res.data.rows
        this.hdzqData.total = res.data.total
      }).catch(err => {
        console.log('失败:' + err)
      })
    },
    hzsjDetail () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getCooperateSignup,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id
        })
      ).then(res => {
        this.hzbmItem = res.data.obj
      }).catch(err => {
        console.log('失败:' + err)
      })
      // this.customGlobal.postHttpClient(
      //   this.customGlobal.serverUrl.getCooperativeMerchants,
      //   this.customGlobal.serverUrl.orgBaseURI,
      //   {'Content-Type': 'application/x-www-form-urlencoded'},
      //   this.qs.stringify({
      //     bank_id: this.pri_detail.activityObj.city_id
      //   })
      // ).then(res => {
      //   this.tcm_img_path = res.data.obj.tcm_img_path
      // }).catch(err => {
      //   console.log('失败:' + err)
      // })
    },
    fljnDetail () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getWelfareTips,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id
        })
      ).then(res => {
        this.twt_img_path = res.data.obj.twt_img_path
      }).catch(err => {
        console.log('失败:' + err)
      })
    },
    bfrxDetail () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getServiceCenter,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id
        })
      ).then(res => {
        this.kfzxList = res.data.rows
        this.bfrxDialog = true
      }).catch(err => {
        console.log('失败:' + err)
      })
    },
    yyzzDetail () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getOperationQualification,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id
        })
      ).then(res => {
        this.toq_img_path = res.data.obj.toq_img_path
      }).catch(err => {
        console.log('失败:' + err)
      })
    },
    xkzxlist () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getNewcustomerExclusiveAll,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_center_id: this.pri_detail.activityObj.bank_center_id,
          province_id: this.pri_detail.activityObj.province_id,
          city_id: this.pri_detail.activityObj.city_id,
          county_id: this.pri_detail.activityObj.county_id,
          station_id: this.pri_detail.activityObj.station_id,
          perPageSize: this.xkzxData.perPageSize,
          currentPage: this.xkzxData.currentPage
        })
      ).then(res => {
        this.xkzxData.rows = res.data.rows
        this.xkzxData.total = res.data.total
      }).catch(err => {
        console.log('失败:' + err)
      })
    },
    getAllBankActAll () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getAllBankActAll,
        this.customGlobal.serverUrl.orgBaseURI,
        {"Content-Type": "application/x-www-form-urlencoded"},
        this.qs.stringify({
          bank_center_id: this.pri_detail.activityObj.bank_center_id,
          province_id: this.pri_detail.activityObj.province_id,
          city_id: this.pri_detail.activityObj.city_id,
          county_id: this.pri_detail.activityObj.county_id,
          station_id: this.pri_detail.activityObj.station_id,
          perPageSize: this.qhhdData.perPageSize,
          currentPage: this.qhhdData.currentPage
        })
      ).then(res => {
        console.log(res)
        this.qhhdData.rows = res.data.rows
        this.qhhdData.total = res.data.total
      }).catch(err => {
        console.log("失败:" + err)
      })
    },
    pre_page_xkzx () {
      if (this.xkzxData.currentPage === 1) {
        this.$message({
          message: '当前已经是第一页了',
          duration: '1500'
        })
        return false
      }

      this.xkzxData.currentPage--
      this.xkzxlist()
    },
    next_page_xkzx () {
      var tail = Math.ceil(parseFloat(this.xkzxData.total) / parseFloat(this.xkzxData.perPageSize))
      if (this.xkzxData.currentPage === tail) {
        this.$message({
          message: '当前已经是最后一页了',
          duration: '1500'
        })
        return false
      }

      this.xkzxData.currentPage++
      this.xkzxlist()
    },
    pre_page_qhhd () {
      if (this.qhhdData.currentPage === 1) {
        this.$message({
          message: '当前已经是第一页了',
          duration: '1500'
        })
        return false
      }

      this.qhhdData.currentPage--
      this.getAllBankActAll()
    },
    next_page_qhhd () {
      var tail = Math.ceil(parseFloat(this.qhhdData.total) / parseFloat(this.qhhdData.perPageSize))
      if (this.qhhdData.currentPage === tail) {
        this.$message({
          message: '当前已经是最后一页了',
          duration: '1500'
        })
        return false
      }

      this.qhhdData.currentPage++
      this.getAllBankActAll()
    },
    pre_page_hdzq () {
      if (this.hdzqData.currentPage === 1) {
        this.$message({
          message: '当前已经是第一页了',
          duration: '1500'
        })
        return false
      }

      this.hdzqData.currentPage--
      this.hdzqlist()
    },
    next_page_hdzq () {
      var tail = Math.ceil(parseFloat(this.hdzqData.total) / parseFloat(this.hdzqData.perPageSize))
      if (this.hdzqData.currentPage === tail) {
        this.$message({
          message: '当前已经是最后一页了',
          duration: '1500'
        })
        return false
      }

      this.hdzqData.currentPage++
      this.hdzqlist()
    },
    get_contact () {
      this.saveBankViewCountDay(3)
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getContactByBankId,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.station_id,
          cui_type: '5',
          // bank_id: this.pri_detail.activityObj.city_id,
          // cui_type: '3',
        })
      ).then(res => {
        this.sjbank_data = res.data.obj
      }).catch(err => {
        console.log('失败:' + err)
      })
    },

    get_client_list () {
      this.saveBankViewCountDay(1)
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getClienteleServicesList,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id,
          cui_type: '3',
          perPageSize: 7,
          currentPage: 1
        })
      ).then(res => {
        this.kefu_data_list = res.data
      }).catch(err => {
        console.log('失败:' + err)
      })
    },

    get_official_list1 () {
      this.saveBankViewCountDay(2)
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getOfficialList,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id,
          cui_type: '3',
          perPageSize: 8,
          currentPage: 1
        })
      ).then(res => {
        this.wxaccount_data_list = res.data
        console.log(res)
      }).catch(err => {
        console.log('失败:' + err)
      })
    },

    getSoundPathByCondition () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getSoundPathByCondition,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          cui_type: '5',
          bank_center_id: this.pri_detail.activityObj.bank_center_id,
          province_id: this.pri_detail.activityObj.province_id,
          city_id: this.pri_detail.activityObj.city_id,
          county_id: this.pri_detail.activityObj.county_id,
          station_id: this.pri_detail.activityObj.station_id
        })
      ).then(res => {
        this.audios = {}
        for (let i in res.data.map) {
          this.audios['audio' + i] = new Audio()
          this.audios['audio' + i].src = res.data.map[i]
          this.audios['audio' + i].play()
          this.audios['audio' + i].pause()
        }
      }).catch(err => {
        console.log('失败:' + err)
      })
    },
    playAudio (index) {
      if (this.audios.hasOwnProperty('audio' + index)) {
        this.audios['audio' + index].play()
      }
    },

    get_station_list () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getStationContactList,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id,
          cui_type: '3',
          tbsc_area: this.stationAreasOption,
          perPageSize: this.stationTableData.perPageSize,
          currentPage: this.stationTableData.currentPage
        })
      ).then(res => {
        this.stationTableData.rows = res.data.rows
        this.stationTableData.total = res.data.total
      }).catch(err => {
        console.log('失败:' + err)
      })
    },

    get_station_areas_list () {
      this.customGlobal.postHttpClient(
        this.customGlobal.serverUrl.getStationContactAreas,
        this.customGlobal.serverUrl.orgBaseURI,
        {'Content-Type': 'application/x-www-form-urlencoded'},
        this.qs.stringify({
          bank_id: this.pri_detail.activityObj.city_id,
          cui_type: '3',
        })
      ).then(res => {
        this.station_areas_options = res.data.rows
      }).catch(err => {
        console.log('失败:' + err)
      })
    },

    tableHeaderStyle ({row, column, rowIndex, columnIndex}) {

      if (rowIndex === 1 && columnIndex === 0) {
        return 'text-align: center;padding-left: 0;padding-right: 10px;color:#000000;'
      } else if (rowIndex === 0 && columnIndex === 0) {
        return 'padding-right: 10px;color:#000000;'
      } else {
        return 'text-align: center;color:#000000;'
      }
    },

    zizhi_show () {
      if(!this.manjian_data.bmi_business_license) {
        this.$message({
          message: '商家未上传经营资质',
          duration: '1500'
        })
        return
      }
      this.zizhi_dialog = true
    },

    close_click1 () {
      this.zizhi_dialog = false
    }

  }
}
</script>
<style scoped>

.custom-btn:active {
  background-color: red; /* 点击时的背景颜色 */
  color: white; /* 点击时的文字颜色 */
}

.tableStyle {
  color: #fff;
  padding-left: 20px;
}

.simple-keyboard {
  max-width: 850px;
  padding: 15px;
  margin: 0 auto;
  margin-top: 10px;
  box-shadow: 0 4px 0 #b2b2b2, 0 7px 16px rgba(0, 0, 0, 0.6);
}

.hg-theme-default .hg-button.hg-standardBtn {
  height: 130px;
  margin: 8px 10px;
  font-size: 30px;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0, 0, 0, 0.7);
  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0, 0, 0, 0.7);
}

.hg-theme-default .hg-button.hg-standardBtn:active {
  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0, 0, 0, 0.9);
  background-color: #efefef;
}

.simple-keyboard.hg-layout-default .hg-button.bksp {
  height: 130px;
  margin: 8px 0 8px 12px;
  font-size: 30px;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0, 0, 0, 0.7);
  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0, 0, 0, 0.7);
  background: #fb9163;
  color: white;
}

.simple-keyboard.hg-layout-default .hg-button.bksp:active {
  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0, 0, 0, 0.9);
  background-color: #efefef;
  color: #000000;
}

.simple-keyboard.hg-layout-default .hg-button.enter {
  height: 130px;
  margin: 8px 10px 8px 8px;
  font-size: 30px;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0, 0, 0, 0.7);
  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0, 0, 0, 0.7);
  background: #fb9163;
  color: white;
}

.simple-keyboard.hg-layout-default .hg-button.enter:active {
  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0, 0, 0, 0.9);
  background-color: #efefef;
  color: #000000;
}

.click_back:active {
  color: red;
}

.click_border:active {
  border: 2px solid red;
  border-radius: 5px;
}

.click_border1 {
  border: 2px solid #c0c4cc;
}

.click_border1:active {
  border: 2px solid red;
  border-radius: 5px;
}

.v-touch {
  touch-action: pan-y !important;
}

.new-item1 /deep/ .el-carousel__indicator--horizontal > .el-carousel__button {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #d2d7dc;
  margin: 5px 10px 0 10px;
}

.new-item2
/deep/
.el-carousel__indicator--horizontal.is-active
> .el-carousel__button {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #fec58e;
  margin: 5px 10px 0 10px;
}

.zzc_box {
  width: 1080px;
  height: 1920px;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: block;
}

.account-plat-formitem /deep/ .el-form-item {
  margin-bottom: 3px !important;
}

.el-form-item {
  margin-bottom: 5px !important;
}

.input1 /deep/ .el-input__inner {
  height: 51px;
  font-size: 30px;
}

.input2 /deep/ .el-form-item__error {
  margin: 240px 0 0 130px;
  font-size: 20px;
}

.cake {
  animation: move 2s 0s 50 forwards;
  -webkit-animation: move 2s 0s 50 forwards;
  transform-origin: bottom;
  -webkit-transform-origin: bottom;
}

@keyframes move {
  0%,
  65% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  70% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  75% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  80% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  85% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  90% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  95% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

@-webkit-keyframes move {
  0%,
  65% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  70% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  75% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  80% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  85% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  90% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }

  95% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }

  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.new-item3 /deep/ .el-carousel__button {
  margin-left: -100px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: #d2d7dc;
  margin-top: 10px;
}

.new-item4 /deep/ .is-active .el-carousel__button {
  background: red;
  margin-left: -100px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  margin-top: 10px;
}

.banner /deep/ .el-carousel__indicator .el-carousel__indicator--horizontal {
  position: absolute;
  bottom: 0;
  left: 0;
}

.box >>> .el-card__body {
  padding: 0 !important;
  margin: 0 !important;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.image_frame {
  background-size: 99%;
  width: 240px;
  height: 240px;
  background-repeat: no-repeat;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image_frame1 {
  background-size: 99%;
  width: 750px;
  height: 400px;
  background-repeat: no-repeat;
  margin: 50px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wxts_btn {
  width: 110px;
  height: 31px;
  line-height: 31px;
  margin: 10px auto;
  font-size: 18px;
  font-weight: 600;
  /*letter-spacing: 4px;*/
  /*border-radius: 15px;*/
  background-color: rgb(240, 163, 83);
  /*box-shadow: rgb(125, 125, 125) -2px 2px 2px 2px;*/
}

.header_container {
  /*background: url("../../../../assets/images/tu2.png");*/
  background-position: center;
}

.part1 {
  /*background-color: #FFFFFF;*/
  background-color: #e8e8e8;
  border-radius: 16px;
  width: 1000px;
  height: 415px;
  padding: 0 20px;
  margin: 0px 20px 10px 20px;
}

.part2 {
  width: 1000px;
  height: 305px;
  margin: 20px 20px 10px 20px;
  padding: 0 20px;
  background-color: #e8e8e8;
  border-radius: 16px;
}

.part3 {
  width: 1000px;
  height: 330px;
  margin: 20px 20px 0 20px;
  padding: 0 20px;
  background-color: #e8e8e8;
  border-radius: 16px;
}
.relative-div {
  position: absolute;
  top: 10px; /* 向下移动10px */
  right: 10px; /* 向右移动20px */
}
.part_font {
  font-size: 20px;

  font-weight: 400;
  color: #A78854;
  line-height: 36px;
}

.part_font_click {
  font-size: 20px;

  font-weight: 400;
  color: #E02E24;
  line-height: 36px;
}
.supermarket_font {
  font-size: 30px;

  font-weight: bold;
  color: #79520F;
  line-height: 36px;
}

.supermarket_font_click {
  font-size: 35px;

  font-weight: bold;
  color: #AA2C00;
  line-height: 36px;
}
.supermarket_content {
  width: 100%;
  height: 100%;
  margin: 30px 46px 23px 34px;
  display: flex;
}
.hdzq_content {
  width: 100%;
  height: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hdzq_content_div {
  width: 771px;
  height: 50px;
  display: flex;
  font-size: 28px;
  color: #FFFFFF;
  background-color: #ff4d4d;
  border-top-left-radius: 10px; /* 左上角圆角 */
  border-top-right-radius: 10px; /* 左上角圆角 */
  padding-left: 10px;
  align-items: center;
}
.xlh_content_div {
  width: 471px;
  height: 70px;
  display: flex;
  flex-direction: column;
  font-size: 22px;
  color: #FFFFFF;
  background-color: #ff4d4d;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  padding-left: 20px;
  margin: 15px 10px;
  justify-content: center;
  align-items: flex-start;
}
.text-div {
  display: inline-block; /* 行内块元素宽度由内容决定 */
  white-space: nowrap;   /* 禁止文本换行 */
}
.dot {
  color: #ffffff;
  margin-right: 0.3em;
}

.hdzq_content_describer {
  width: 771px;
  height: 355px;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  color: #79520F;
  background-color: #ffffff;
  border-radius: 15px;
  margin-bottom: 30px;
}
.xkzx_content_describer {
  width: 771px;
  height: 225px;
  display: flex;
  font-size: 18px;
  color: #000000;
  background-color: #ffffff;
  border-bottom-left-radius: 10px; /* 左上角圆角 */
  border-bottom-right-radius: 10px; /* 左上角圆角 */
  margin-bottom: 20px;
}
.custom-textarea-hdzq {
  height: 168px;
  width: 582px;
  white-space:pre-line;
  line-height: 20px;
  text-align: left;
  font-size: 14px;

  padding:5px 25px;
}
.custom-textarea-xkzx {
  width: 621px;
  white-space:pre-line;
  line-height: 20px;
  text-align: left;
  font-size: 14px;

  padding:4px 10px;
}
.xkzx_content {
  width: 99%;
  height: 45px;
  background-color: #ffeae2;
  margin-bottom: 5px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
}
.qhhd_content {
  width: 99%;
  height: 180px;
  background-color: #ffeae2;
  margin-bottom: 5px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
}
/*.el-textarea.is-disabled /deep/ .el-textarea__inner {*/
/*  color: #79520F;*/
/*  background-color: #ffffff;*/
/*}*/
/*/deep/ .custom-textarea-hdzq textarea {*/
/*  height: 168px; !* 设置具体的高度值 *!*/
/*  width: 532px;*/
/*  color: #79520F;*/
/*  border: none;*/
/*  box-shadow: none;*/
/*  resize: none;*/
/*  overflow-y: hidden; !* 垂直滚动条 *!*/
/*  !*:deep(.el-textarea__inner){*!*/
/*  !*  height: 349px;*!*/
/*  !*}*!*/
/*}*/
.supermarket_title_div {
  background-color: #d9d9d9;
  /*border-radius: 5px;*/
  border-top-left-radius: 10px; /* 左上角圆角 */
  border-bottom-left-radius: 10px; /* 左下角圆角 */
  border-right: none; /* 右边边框为直角 */
  /*border: 1px solid #000000;*/
  height: 46px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.supermarket_title_div_click {
  background-color: #ffa60b;
  border-top-left-radius: 10px; /* 左上角圆角 */
  border-bottom-left-radius: 10px; /* 左下角圆角 */
  border-right: none; /* 右边边框为直角 */
  /*border: 1px solid #000000;*/
  height: 46px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
}
.supermarket_title {
  display: flex;
  flex-direction: column;
  width: 140px;
  height: 1200px;
  font-size: 24px;
}
.content {
  width: 213px;
  height: 100%;
  margin: 0px 49px 10px 0px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  position: relative;
  background-color: #FFFFFF;
}
.content_mask {
  width: 213px;
  height: 100%;
  margin: 0px 30px 10px 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 10px;
  background-color: #FFFFFF;
}
.content_mask::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5); /* 半透明遮罩 */
}

.content2 {
  background: url('../../../../assets/images/hongbao.png');
  width: 151px;
  height: 214px;
  display: flex;
  flex-direction: column;
}

.content2-c {
  background: url('../../../../assets/images/hongbao.png');
  width: 151px;
  height: 214px;
  display: flex;
  flex-direction: column;
  margin: 0px 5px 5px;
}

.content3 {
  /*background: url('../../../../assets/images/tu7.png') no-repeat;*/
  width: 477px;
  height: 114px;
  margin-bottom: 10px;
  border-radius: 10px;
  background-color: #ffffff;
}

.content4 {
  /*background: url('../../../../assets/images/tu7.png') no-repeat;*/
  width: 392px;
  height: 113px;
  margin: 0 5px 10px;
  border-radius: 10px;
  background-color: #ffffff;
}

.content_img {
  width: 213px;
  height: 188px;
  margin-bottom: 6px;
  border-radius: 10px;
  background-color: #FFFFFF;
}

.tip_kuang {
  background: url('../../../../assets/images/tu5.png');
  width: 48px;
  height: 20px;
}

.tip_foot {
  background: url('../../../../assets/images/tu6.png');
  width: 200px;
  height: 36px;
  margin:auto;
  margin-bottom: 10px;
  /*margin: 0 12px 7px 10px;*/
  display: flex;
}

.tip_foot_font {
  height: 18px;
  font-size: 18px;

  font-weight: 400;
  /*color: #E02E24;*/
  margin: 4px 4px 7px 13px;
}

.ling {
  width: 72px;
  height: 21px;
  line-height: 21px;
  background-color: #ee3634;
  border-radius: 10px;
  margin-top: 5px;
}

.ling1 {
  background: url('../../../../assets/images/tu8.1.png');
  width: 86px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tar-line {
  height: 3px;
  background-color: rgb(254, 107, 40);
}

.dialog_msg {
  width: 1000px;
  height: 1066px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
}

.dialog_msg_fail {
  width: 810px;
  height: 606px;
  position: fixed;
  flex-direction: column;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
  background-color: #f1c172;
  border-radius: 25px;
}

.dialog_zxbz {
  width: 790px;
  height: 606px;
  position: fixed;
  flex-direction: column;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
}

.dialog_box {
  background: url('../../../../assets/images/tu9.png') no-repeat;
  background-size: 100% 100%;
  width: 858px;
  height: 1066px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
}

.dialog_box_supermarket {
  background: url('../../../../assets/images/tu9.png') no-repeat;
  background-size: 100% 100%;
  width: 838px;
  height: 1450px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
}
.dialog_box_hdzq {
  background: url('../../../../assets/images/tu9.png') no-repeat;
  background-size: 100% 100%;
  width: 838px;
  height: 1076px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
  white-space:normal;
  word-break:break-all;
  word-wrap:break-word;
}
.div_line {
  font-size: 25px;
  margin-left:20px;
  margin-right:20px;
}

.dialog_box_ticket {
  background: url('../../../../assets/images/tu9.png') no-repeat;
  background-size: 100% 100%;
  width: 818px;
  height: 1286px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
  white-space:normal;
  word-break:break-all;
  word-wrap:break-word;
}

.dialog_box1 {
  background: url('../../../../assets/images/tu14.png') no-repeat;
  background-size: 100% 100%;
  width: 818px;
  height: 1266px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 200;
}

.box_part1 {
  background: url('../../../../assets/images/tu10.png') no-repeat;
  background-size: 100% 100%;
  width: 772px;
  height: 190px;
  margin: 29px 0 10px 23px;
}

.box_part2 {
  background: url('../../../../assets/images/tu11.png') no-repeat;
  background-size: 100% 100%;
  width: 775px;
  height: 236px;
  margin: 0 0 10px 23px;
  display: flex;
}

.box_part3 {
  background: url('../../../../assets/images/tu12.png') no-repeat;
  background-size: 100% 100%;
  width: 775px;
  margin: 0 0 10px 23px;
  height: 620px;
  overflow: auto;
}

.box_part4 {
  background: url('../../../../assets/images/tu15.png') no-repeat;
  background-size: 100% 100%;
  width: 771px;
  height: 1049px;
  margin: 8px 0 0 24px;
}

.box_part9 {
  background: url('../../../../assets/images/tu21.png') no-repeat;
  background-size: 100% 100%;
  width: 810px;
  height: 849px;
  margin: 8px 0 0 24px;
}
.box_part10 {
  background-color: #e8e8e8;
  border-radius: 16px;
  width: 810px;
  height: 849px;
  margin: 8px 0 0 24px;
}
.dashed {
  width: 98%;
  margin: 2px 0px;
  border: 2px dashed black; /* 设置边框为1像素的黑色虚线 */
}
.dashed-shu {
  width: 2px;
  height: 100%;
  margin: 0px 5px;
  border: 2px dashed black; /* 设置边框为1像素的黑色虚线 */
}
.dashed-hdzq {
  width: 1px;
  height: 180px;
  margin: 5px 5px;
  border: 1px dashed #A3A3A3; /* 设置边框为1像素的黑色虚线 */
}

.dashed-xkzx {
  width: 1px;
  height: 210px;
  margin: 5px 5px;
  border: 1px dashed #e0a800; /* 设置边框为1像素的黑色虚线 */
}
.dashed-border {
  height: 210px;
  background-image: linear-gradient(to bottom, #A3A3A3 50%, transparent 50%);
  background-size: 1px 15px; /* 第一部分长度 */
  background-repeat: repeat-y;
  width: 1px; /* 或者其他需要的尺寸 */
}
.image-container {
  border: 1px dashed #ccc; /* 虚线边框 */
  display: inline-block;
}
.box_part_supermarket {
  width: 598px;
  height: 1200px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:center;
  padding: 0px 10px;
}
.box_supermarket_content_noimage {
  width: 572px;
  height: 891px;
  display: flex;
  font-size: 18px;
  opacity: 0.7;
  /*white-space:pre-line;*/
  /*word-break:break-all;*/
  /*word-wrap:break-word;*/
  overflow-y: hidden; /* 垂直滚动条 */
  overflow-x: hidden; /* 隐藏水平滚动条 */
  margin-bottom: 15px;
}
/deep/ .custom-textarea_noimage textarea {
  height: 891px; /* 设置具体的高度值 */
  width: 100%;
  border: none;
  box-shadow: none;
  resize: none;
  overflow-y: hidden; /* 垂直滚动条 */
  /*:deep(.el-textarea__inner){*/
  /*  height: 349px;*/
  /*}*/
}
.box_supermarket_content {
  width: 572px;
  height: 739px;
  display: flex;
  font-size: 18px;
  opacity: 0.7;
  /*white-space:pre-line;*/
  /*word-break:break-all;*/
  /*word-wrap:break-word;*/
  overflow-y: hidden; /* 垂直滚动条 */
  overflow-x: hidden; /* 隐藏水平滚动条 */
  margin-bottom: 15px;
}
/deep/ .custom-textarea textarea {
  height: 739px; /* 设置具体的高度值 */
  width: 100%;
  border: none;
  box-shadow: none;
  resize: none;
  overflow-y: hidden; /* 垂直滚动条 */
  /*:deep(.el-textarea__inner){*/
  /*  height: 349px;*/
  /*}*/
}
/deep/ .no-border-input textarea {
  height: 109px;
  border: none;
  box-shadow: none;
  resize: none;
}
.box_shop {
  display: flex;
  flex-direction: column;
  width:100%;
  height: 200px;
  line-height: 35px;
  font-size: 23px;

  color: #333333;
  align-items:baseline;
  justify-content:center;
  margin-top: 35px;
}
.shop_btn {
  width: 140px;
  height: 96px;
  border: 5px solid #e3e3e3;
  border-radius: 10px;
  color:#000000;
  background-color: #e3e3e3;
  display: flex;
  justify-content:center;
  align-items:center;
  font-size: 16px;
  font-weight: bold;
  flex-direction: column;
}

.shop_btn_click {
  width: 140px;
  height: 96px;
  border: 5px solid #a10900;
  border-radius: 10px;
  color:#ffffff;
  background-color: #a10900;
  display: flex;
  justify-content:center;
  align-items:center;
  font-size: 16px;
  font-weight: bold;
  flex-direction: column;
}

.shop_bg {
  width: 140px;
  height: 76px;
  display: flex;
  justify-content:center;
}

.shop_bg_click {
  width: 67px;
  height: 32px;
  background: url('../../../../assets/images/shop_jt.png')  no-repeat;
  background-size: 100% 100%;
}

.box_part5 {
  background: url('../../../../assets/images/tu16.png')no-repeat;
  background-size: 100% 100%;
  width: 683px;
  height: 173px;
  margin: 12px 0 0 42px;
  text-align: left;
  padding: 10px 16px 0 16px;
  font-size: 20px;

  font-weight: bold;
  color: #1B1B1B;
}

.box_part6 {
  width: 688px;
  height: 100px;
  margin: 0 0 0 42px;
  text-align: left;
  padding: 4px 10px 0 10px;
  font-size: 18px;

  font-weight: bold;
  border: 1px dashed  #000000; border-radius: 4px;
  color: #1B1B1B;
}

.box_part7 {
  background: url('../../../../assets/images/tu18.png');
  width: 150px;
  min-height: 180px;
  height: auto;
  margin: 3px 0 0 0;
  font-size: 16px;

  color: #000000;
  text-align: left;
  padding: 6px 7px 0 7px;
}

.box_part8 {
  background: url('../../../../assets/images/tu19.png');
  width: 98px;
  height: 35px;
  margin-top: 6px;
  padding-top: 4px;

  font-weight: 400;
  color: #868685;

}

.box_foot {
  background: url('../../../../assets/images/tu13.png') no-repeat;
  background-size: 100% 100%;
  width: 147px;
  height: 90px;
}
.wxts_bg {
  position: absolute;
  background: url('../../../../assets/images/wxts_bg.png') no-repeat;
  background-size: 100% 100%;
  width: 450px;
  height: 173px;
  /*top:57%;*/
  top:610px;
  left:204px;
  z-index: 300;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.box_foot_content {
  font-size: 20px;

  font-weight: bold;
  color: #313131;
  line-height: 30px;
  margin: 17px 0px 20px 10px;
  text-align: left;
}

.dialog-detail {
  width: 1080px;
  height: 1920px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 1050;
  background-color: rgba(0, 0, 0, .63)
}

.dialog {
  width: 1080px;
  height: 1920px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .63)
}

.dialog1 {
  width: 600px;
  height: 300px;
  position: fixed;
  top: 400px;
  right: 0;
  left: 0;
  margin: auto;
  z-index: 1100;
  background-color: rgba(0, 0, 0, .63);
}

.biaoqian {
  background: url('../../../../assets/images/biaoqian.png');
  position: absolute;
  z-index: 201;
  top: 228px;
  left: 37px;
  width: 70px;
  height: 90px;
  display: flex;
  flex-direction: column;
}

/deep/ .el-table td, .el-table th {
  padding: 0;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

/deep/ .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
  padding-left: 0;
}

/deep/ .el-table .cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 2px 2px 0 2px;
}

/deep/ .el-table th > .cell {
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}

.column-style {
  margin-bottom: 50px;
}

* {
  -webkit-user-select: none;
}
.img_title {
  width: 100%;
  height: 100%;
}
.img_title_cursor {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.title_image {
  display: flex;
  flex-direction: column;
  width: 140px;
  align-items: center;
  font-size: 17px;
}
.manjianqu_title {
  height: 20px;
  width: 100%;
  margin: 10px 0 19px 0;
  font-size: 25px;
  /*color: #FF990C*/
}
.manjianqu_title_home {
  width: 100%;
  height: 15px;
  line-height: 15px;
  display: flex;
  justify-content: center;
  margin: 4px 0 0;
  font-size: 16px;
  /*color: #FF990C*/
}
.manjianqu_btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
.manjianqu_bq {
  padding: 30px 2px 0px;
  width: 100%;
  display: flex;
  font-size: 10px;
  flex-wrap: wrap;
}
.manjianqu_bq_home {
  padding: 2px 15px 0px;
  width: 80%;
  height: 20px;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  flex-wrap: wrap;
}
.manjianqu_bq_div {
  width: 68px;
  background-color: #FFFFFF;

  color: #9c9c9c;
  border-radius: 2px;
  margin-top: 5px;
  margin-left: 3px;
  margin-right: 2px;
}
.el-table /deep/ .el-table__body td {
  color: #000000;
}
.el-carousel__indicator {
  pointer-events: none;
}
.el-carousel-none {
  transition: none !important; /* 移除过渡效果 */
}
.contentOut {
  width: 90%;
  height: 930px;
  margin: auto;
  display: flex;
  padding-top: 20px;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
}
.out {
  width: 90%;
  display: flex;
  text-align: left;
  flex-direction: column;
  align-items: flex-start;
  background-color: #f9f4eb;
  margin: 10px 20px;
  padding: 10px;
  min-height: 100px;
  gap:10px;
  box-sizing: border-box;  /* 关键属性 */
  z-index: 0;
  border-radius: 20px;
  font-size: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.outkf {
  width: 90%;
  display: flex;
  text-align: left;
  flex-direction: column;
  align-items: flex-start;
  background-color: #f9f4eb;
  margin: 5px 20px 10px;
  min-height: 155px;
  gap:2px;
  box-sizing: border-box;  /* 关键属性 */
  z-index: 0;
  border-radius: 20px;
  font-size: 18px;
}
.sign_mask {
  width: 100px;
  margin-top: -28px;
  /*margin: 7px 20px 15px 20px;*/
  display: flex;
  padding: 3px;
  justify-content: space-between;
  align-items: center;
  position: relative;
  background-color: #000000;
  opacity: 0.5;
}
.sign_name {
  margin-bottom: 5px; margin-left: 10px;margin-right: 10px;
}
.sign_name::before {
  content: "•"; /* 这里的“•”是一个全角点，你也可以使用其他字符或图片 */
  margin-right: 2px; /* 可选，为点与文本之间添加一些空间 */
}
.img_mask {
  display: flex;
  width:78px;
  border-radius: 10px;
  left: 3px;
  top:22px;
  position: relative;
  z-index: 999;
  color: #FFFFFF;
  background-color: #000000;
  opacity: 0.7;
}
.trapezoid-down-transform {
  width: 100px;
  height: 25px;
  line-height: 25px;
  color: #ffffff;
  background: url('../../../../assets/images/industry.png')  no-repeat;
  background-size: 100% 100%;
  /*transform: perspective(60px) rotateX(-20deg);*/
  /*transform-origin: bottom;*/
  margin: -2px auto 0px;
}
/*.sign_mask::after {*/
/*  content: '';*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  background: rgba(0, 0, 0, 0.8); !* 半透明遮罩 *!*/
/*}*/
#demoCanvas {
  /*position:fixed;*/
  position: absolute;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/views/bankPlatform/deviceIndex/defaultIndex.vue